import { Component, OnInit, ViewChild } from '@angular/core';
import { Router } from '@angular/router';
import { WebapiService } from '../webapi.service';
import * as moment from 'moment';
import { DaterangepickerComponent } from 'ng2-daterangepicker';
import { JSONParser } from '@amcharts/amcharts4/core';
import { ModelpopupComponent } from '../modelpopup/modelpopup.component';
import { ModalController } from '@ionic/angular';
import { OceanShipperDataComponent } from '../ocean-shipper-data/ocean-shipper-data.component';
import { Ocean3b81detailsComponent } from '../ocean3b81details/ocean3b81details.component';
import { ShipercobdataComponent } from '../shipercobdata/shipercobdata.component';
import { IDropdownSettings } from 'ng-multiselect-dropdown';
import { CapacitypredectionComponent } from '../capacitypredection/capacitypredection.component';
import { PartnerdetailsComponent } from '../partnerdetails/partnerdetails.component';



@Component({
  selector: 'app-capacityprediction',
  templateUrl: './capacityprediction.component.html',
  styleUrls: ['./capacityprediction.component.scss'],
})
export class CapacitypredictionComponent implements OnInit {

  uploadstatus=false;

  //   sample data for week

  weekdate=[
    {
      "ORIGIN_BRANCH": "DFW",
      "DESTIN_BRANCH": "AMS",
      "WEEK": "06/08/2023",
      "Predictions Lower": 16504.15,
      "Predictions Upper": 31685,
      "ACTUALS": 19416,
      "COMBINED": 19416,
      "OCEAN": "",
      "ERROR": 0.15,
      "Base": 45000,
      "Min": 0,
      "Flex": 0,
      "Borrow": 0,
      "Pred Overallocation": "N",
      "Pred Underallocation": "N",
      "Actual Overallocation": "N",
      "Actual Underallocation": "N",
      "OverAllocated": "-",
      "Underallocated": "-"
    },
    {
      "ORIGIN_BRANCH": "HKG",
      "DESTIN_BRANCH": "AMS",
      "WEEK": "06/08/2023",
      "Predictions Lower": 105948.49,
      "Predictions Upper": 122245.91,
      "ACTUALS": 94539.5,
      "COMBINED": 166792,
      "OCEAN": 72252.5,
      "ERROR": 0.27,
      "Base": 160000,
      "Min": 52500,
      "Flex": 14000,
      "Borrow": 160000,
      "Pred Overallocation": "N",
      "Pred Underallocation": "N",
      "Actual Overallocation": "N",
      "Actual Underallocation": "N",
      "OverAllocated": "-",
      "Underallocated": "-"
    },
    {
      "ORIGIN_BRANCH": "HKG",
      "DESTIN_BRANCH": "DFW",
      "WEEK": "06/08/2023",
      "Predictions Lower": 106045.07,
      "Predictions Upper": 113288.08,
      "ACTUALS": 109963.5,
      "COMBINED": 109963.5,
      "OCEAN": "",
      "ERROR": 0,
      "Base": 90000,
      "Min": 37500,
      "Flex": 10000,
      "Borrow": 220000,
      "Pred Overallocation": "Y",
      "Pred Underallocation": "N",
      "Actual Overallocation": "Y",
      "Actual Underallocation": "N",
      "OverAllocated": "19,964",
      "Underallocated": "-"
    },
    {
      "ORIGIN_BRANCH": "HKG",
      "DESTIN_BRANCH": "ELP",
      "WEEK": "06/08/2023",
      "Predictions Lower": 139488.8,
      "Predictions Upper": 176201,
      "ACTUALS": 100406.14,
      "COMBINED": 231653.49,
      "OCEAN": 131247.35,
      "ERROR": 0.24,
      "Base": 220000,
      "Min": 52500,
      "Flex": 14000,
      "Borrow": 90000,
      "Pred Overallocation": "N",
      "Pred Underallocation": "N",
      "Actual Overallocation": "N",
      "Actual Underallocation": "N",
      "OverAllocated": "-",
      "Underallocated": "-"
    },
    {
      "ORIGIN_BRANCH": "HKG",
      "DESTIN_BRANCH": "GDL",
      "WEEK": "06/08/2023",
      "Predictions Lower": 46867.99,
      "Predictions Upper": 77748.11,
      "ACTUALS": 29236.17,
      "COMBINED": 42301.27,
      "OCEAN": 13065.1,
      "ERROR": 0.11,
      "Base": 206000,
      "Min": "",
      "Flex": "",
      "Borrow": "",
      "Pred Overallocation": "N",
      "Pred Underallocation": "N",
      "Actual Overallocation": "N",
      "Actual Underallocation": "N",
      "OverAllocated": "-",
      "Underallocated": "-"
    },
    {
      "ORIGIN_BRANCH": "HKG",
      "DESTIN_BRANCH": "PRG",
      "WEEK": "06/08/2023",
      "Predictions Lower": 60789.96,
      "Predictions Upper": 71313.46,
      "ACTUALS": 33687.67,
      "COMBINED": 114391.17,
      "OCEAN": 80703.5,
      "ERROR": 0.38,
      "Base": 160000,
      "Min": 37500,
      "Flex": 10000,
      "Borrow": 160000,
      "Pred Overallocation": "N",
      "Pred Underallocation": "N",
      "Actual Overallocation": "N",
      "Actual Underallocation": "Y",
      "OverAllocated": "-",
      "Underallocated": "3,812"
    },
    {
      "ORIGIN_BRANCH": "HKG",
      "DESTIN_BRANCH": "SIN",
      "WEEK": "06/08/2023",
      "Predictions Lower": 12098.33,
      "Predictions Upper": 13260.89,
      "ACTUALS": 18646.5,
      "COMBINED": 18646.5,
      "OCEAN": "",
      "ERROR": 0.29,
      "Base": 30000,
      "Min": "",
      "Flex": "",
      "Borrow": "",
      "Pred Overallocation": "N",
      "Pred Underallocation": "N",
      "Actual Overallocation": "N",
      "Actual Underallocation": "N",
      "OverAllocated": "-",
      "Underallocated": "-"
    },
    {
      "ORIGIN_BRANCH": "PEN",
      "DESTIN_BRANCH": "GDL",
      "WEEK": "06/08/2023",
      "Predictions Lower": 19693.78,
      "Predictions Upper": 23767.89,
      "ACTUALS": 48632.5,
      "COMBINED": 48632.5,
      "OCEAN": "",
      "ERROR": 0.51,
      "Base": 34738,
      "Min": "",
      "Flex": "",
      "Borrow": "",
      "Pred Overallocation": "N",
      "Pred Underallocation": "N",
      "Actual Overallocation": "Y",
      "Actual Underallocation": "N",
      "OverAllocated": "13,895",
      "Underallocated": "-"
    },
    {
      "ORIGIN_BRANCH": "PVG",
      "DESTIN_BRANCH": "ELP",
      "WEEK": "06/08/2023",
      "Predictions Lower": 6000,
      "Predictions Upper": 20000,
      "ACTUALS": 10615,
      "COMBINED": 23511,
      "OCEAN": 12896,
      "ERROR": 0.15,
      "Base": 75256,
      "Min": "",
      "Flex": "",
      "Borrow": "",
      "Pred Overallocation": "N",
      "Pred Underallocation": "N",
      "Actual Overallocation": "N",
      "Actual Underallocation": "N",
      "OverAllocated": "-",
      "Underallocated": "-"
    }
  ]

    private picker: DaterangepickerComponent;
    start=""
    end=""
    graph:any;
    graph1:any;
   
    dropdownList = [];
    selectedItems = [];
    dropdownSettings:IDropdownSettings;
  
    flag_3b18='g'
    list2=[];
    lc:any;
    opt={minimumFractionDigits:0, maximumFractionDigits: 0}
    opt1={minimumFractionDigits:2, maximumFractionDigits: 2}
    shipeerdata:any=[];
  
    // week=[{"index":731,"Origin":"HKG","Destination":"ELP","Week":1687651200000,"Observed Chargeable Weight":143077.17,"Predicted Chargeable Weight considering Holidays":275600.8953,"Predicted Chargeable Weight":297407.1431,"Moving Avg 2wks":207398.1971,"Moving Avg 4wks":205141.0171,"Moving Avg 3mnths":220337.8218},{"index":730,"Origin":"HKG","Destination":"ELP","Week":1687046400000,"Observed Chargeable Weight":168527.31,"Predicted Chargeable Weight considering Holidays":236444.6484,"Predicted Chargeable Weight":252162.1802,"Moving Avg 2wks":214798.4714,"Moving Avg 4wks":208353.2736,"Moving Avg 3mnths":220120.6977},{"index":729,"Origin":"HKG","Destination":"ELP","Week":1686441600000,"Observed Chargeable Weight":222585.69,"Predicted Chargeable Weight considering Holidays":247244.6809,"Predicted Chargeable Weight":235164.2663,"Moving Avg 2wks":223792.4857,"Moving Avg 4wks":210756.4882,"Moving Avg 3mnths":220155.4276},{"index":728,"Origin":"HKG","Destination":"ELP","Week":1685836800000,"Observed Chargeable Weight":203318.98,"Predicted Chargeable Weight considering Holidays":242409.3158,"Predicted Chargeable Weight":246188.9194,"Moving Avg 2wks":226416.8293,"Moving Avg 4wks":212967.0939,"Moving Avg 3mnths":219781.7532},{"index":727,"Origin":"HKG","Destination":"ELP","Week":1685232000000,"Observed Chargeable Weight":293477.84,"Predicted Chargeable Weight considering Holidays":248172.3879,"Predicted Chargeable Weight":258315.9577,"Moving Avg 2wks":227764.89,"Moving Avg 4wks":214148.6304,"Moving Avg 3mnths":219022.5757},{"index":726,"Origin":"HKG","Destination":"ELP","Week":1684627200000,"Observed Chargeable Weight":226317.52,"Predicted Chargeable Weight considering Holidays":245903.3928,"Predicted Chargeable Weight":250064.1564,"Moving Avg 2wks":218062.5093,"Moving Avg 4wks":214730.2368,"Moving Avg 3mnths":217026.4386},{"index":725,"Origin":"HKG","Destination":"ELP","Week":1684022400000,"Observed Chargeable Weight":270812.52,"Predicted Chargeable Weight considering Holidays":239390.178,"Predicted Chargeable Weight":227169.4482,"Moving Avg 2wks":216392.9614,"Moving Avg 4wks":214552.29,"Moving Avg 3mnths":215983.8828},{"index":724,"Origin":"HKG","Destination":"ELP","Week":1683417600000,"Observed Chargeable Weight":208020.33,"Predicted Chargeable Weight considering Holidays":225129.7355,"Predicted Chargeable Weight":213206.8454,"Moving Avg 2wks":211060.305,"Moving Avg 4wks":213125.7889,"Moving Avg 3mnths":215036.0492},{"index":723,"Origin":"HKG","Destination":"ELP","Week":1682812800000,"Observed Chargeable Weight":74346.02,"Predicted Chargeable Weight considering Holidays":210385.1368,"Predicted Chargeable Weight":223569.7099,"Moving Avg 2wks":201305.495,"Moving Avg 4wks":211787.7293,"Moving Avg 3mnths":214596.0844},{"index":722,"Origin":"HKG","Destination":"ELP","Week":1682208000000,"Observed Chargeable Weight":163727.85,"Predicted Chargeable Weight considering Holidays":257654.3277,"Predicted Chargeable Weight":251818.4241,"Moving Avg 2wks":200928.9343,"Moving Avg 4wks":218759.2525,"Moving Avg 3mnths":215495.362},{"index":721,"Origin":"HKG","Destination":"ELP","Week":1681603200000,"Observed Chargeable Weight":235764.02,"Predicted Chargeable Weight considering Holidays":296021.1542,"Predicted Chargeable Weight":279069.5592,"Moving Avg 2wks":199044.85,"Moving Avg 4wks":220962.235,"Moving Avg 3mnths":215374.3026},{"index":720,"Origin":"HKG","Destination":"ELP","Week":1680998400000,"Observed Chargeable Weight":276014.32,"Predicted Chargeable Weight considering Holidays":309246.929,"Predicted Chargeable Weight":291653.2429,"Moving Avg 2wks":196723.2879,"Moving Avg 4wks":218699.2521,"Moving Avg 3mnths":214204.3857},{"index":719,"Origin":"HKG","Destination":"ELP","Week":1680393600000,"Observed Chargeable Weight":211012.69,"Predicted Chargeable Weight considering Holidays":269003.4243,"Predicted Chargeable Weight":288330.3407,"Moving Avg 2wks":191820.5507,"Moving Avg 4wks":218346.5379,"Moving Avg 3mnths":213572.9766}]
  week=[];
    selectedday=0;
    totalavailable=0;
    flex=0;
    base=0;
    totalallocated=0;
    user={
  
      lane:'HKG-AMS',
      date:'5/12/2022',
      oring:'HKG',
      destination:'AMS',
      startdate:'6/25/2023',
      enddate:'7/1/2023',
      desti:'AMS',
      week:'6/25/2023',
      partner:''
    }
    bchart:any;
    // bchart_sl:any;
  
    flag=false;
    alldata:any;
    dpartner=[]
    graphdata=[];
    datelistt=[];
    resultdata = {
      partner_date:[],
      partner:[],
      date:[],
      total:{"df_total_recepit": 120184.5, "df_total_booked": 120184.5, "df_total_cob": 120184.5},
      week_snap:[],
      partner_config:[],
      alldate:[],
      sl_date:[],
      sl_partner_Date:[]
  
    }
    resultdata1 = {
      partner_date:[],
      partner:[],
      date:[],
      total:{"df_total_recepit": 120184.5, "df_total_booked": 120184.5, "df_total_cob": 120184.5},
      week_snap:[],
      partner_config:[],
      dateall:[]
  
    }
    sl_partnerlist:any=[];
    //charts
     donatchart_total:any;
     donatchart_total_cob:any;
  
     weeekday=['Sun','Mon','Tue','Wed','Thu','Fri','Sat']
     fullweeekday=['Sunday','Monday','Tuesday','Wedensday','Thursday','Friday','Saturday']
  
     partnergraphlist=[];
     movingbarchart:any;
     selecteddaydonat:any;
     selecteddaydonat_res:any;
     selecteddaydonat_booked:any;
  
     selecteddaydonat_sl:any;
     selecteddaydonat_res_sl:any;
     selecteddaydonat_booked_sl:any;
  
  
     selecteddayBar:any;
  
     allocation = {
       totalallocation:0,
       partnerallocation:[],
       base:0,
       flex:0
     }
     allocation_donat:any
     allocationconsumeline:any;
     public daterange: any = {};
   
     // see original project for full list of options
     // can also be setup using the config service to apply to multiple pickers
     public options: any = {
       locale: { format: 'MM-DD-YYYY' },
       alwaysShowCalendars: false,
      //  maxDate:'07/25/2023',
      "startDate": moment().subtract(1, 'weeks').startOf('week'),
      "endDate": moment().subtract(1, 'weeks').endOf('week'),
    //    "maxSpan": {
    //     "days": 6
    //  },
     "autoApply": true,
  
       ranges :{
        'Current Week' : [moment().startOf('week'), moment().endOf('week')],
        'Last Week' : [moment().subtract(1, 'weeks').startOf('week'),
        moment().subtract(1, 'weeks').endOf('week')]
  
       }
  
     };
     
    //  @ViewChild(DaterangepickerComponent)
    //  public updateDateRange(start,end): void {
    //      this.picker.datePicker.setStartDate('2017-03-27');
    //      this.picker.datePicker.setEndDate('2017-04-08');
    //  }
    
    lanelist=[];
    backlog_lane=[];

    //for capacity predection 


    prediction_list_all_lane:any=[];
    partner_config:any=[];
    weak_list:any=[]

    selectedlanes="";
    constructor(public service:WebapiService,public router:Router,public modalController:ModalController) { 
  
  
      // this.service.postData(this.user, 'get_demand_sensing_lane').then((result) => {
  
      // });
  
      this.selectedItems=['HKG-AMS','HKG-ELP','HKG-DFW','HKG-PRG','HKG-NRT','HKG-DFW','HKG-PEN']
      
      this.service.postData(this.user, 'get_weekly_prediction').then((result) => {
      
        var res:any=result;


        this.prediction_list_all_lane = JSON.parse(res.df_json);
        this.partner_config = JSON.parse(res.partner_lane_config_json);

        console.log(this.prediction_list_all_lane);
        console.log(this.partner_config);

        this.getfilteredlane();
        this.get_distinct_week();
    
      });
      
  

  
    }

    dflag=false;
    download(type,i) {

    //   this.service.postData({}, 'download/'+type).then((result) => {
    //     var temp: any = result;
    //     this.resultr = temp
    //     console.log(this.resultr);
    
    // })
    
    this.dflag=true;
    this.service.download(type).then((result) => {
      
      this.dflag=false;
    
    });
    }
    uploadstatus_message=""
    upload(e)
     {
       
         this.uploadstatus=true;
         this.uploadstatus_message="Please wait.."
   
         var form_data = new FormData();  
               //console.log(model);
               console.log(e.target.files)
               for(var i=0;i<e.target.files.length;i++)
                   form_data.append('file', e.target.files.item(i)); 
               
                   form_data.append('type', 'All Historic and Prediction Data Log released updated'); 
                   form_data.append('uby', localStorage.getItem("email")); 
   
                   this.service.postData1(form_data, 'upload').then((result) => {
                     var temp: any = result;
                     console.log("2");
                     this.uploadstatus=true;
                     this.uploadstatus_message="File uploaded..now updating the changes"

                     this.service.postData(this.user, 'update_weekly_predictions_bulk').then((result) => {
                      this.service.postData(this.user, 'get_weekly_prediction').then((result) => {

                      this.uploadstatus_message="Refreshing the dashboard"

      
                      var res:any=result;
              
              
                      this.prediction_list_all_lane = JSON.parse(res.df_json);
                      this.partner_config = JSON.parse(res.partner_lane_config_json);
              
                      console.log(this.prediction_list_all_lane);
                      console.log(this.partner_config);
              
                      this.getfilteredlane();
                      this.get_distinct_week();
                      this.grapgflag='s'
 
                    });
               
                  });
               }).catch(e => {
                 this.uploadstatus=true;
                 this.uploadstatus_message="Somthing goes wrong!";
                    
               });
       
              
     }
    getarrraybykey(key){

      var array=[]
      this.alldatalane.forEach(element => {
        
        array.push(element[key])

      }); 
      return array;
    }
    uflag=false;
    Apply(){
  
      this.uflag=true;
       var obj = {
        origin:this.selectedlanes.split('-')[0],
        destination:this.selectedlanes.split('-')[1],
        lower:this.getarrraybykey('Predictions Lower (Consensus Forecast)'),
        upper:this.getarrraybykey('Predictions Upper (Consensus Forecast)'),
        type_f:'All Historic and Prediction Data Log released'
       } 
       console.log(obj);
       this.service.postData(obj, 'update_weekly_predictions').then((result) => {
        console.log(result);
//        this.onChangeFunction()
            this.service.postData(this.user, 'get_weekly_prediction').then((result) => {
                  
              var res:any=result;


              this.prediction_list_all_lane = JSON.parse(res.df_json);
              this.partner_config = JSON.parse(res.partner_lane_config_json);

              console.log(this.prediction_list_all_lane);
              console.log(this.partner_config);

              this.getfilteredlane();
              this.get_distinct_week();
              this.uflag=false;


            });

       });
    }

      async gotopartner(week,origin,destination) {
        const modal = await this.modalController.create({
          component: PartnerdetailsComponent,
          componentProps: {
             weekdata: week,
             origin:origin,
             destination:destination
          }
        });
        return await modal.present();
      }
    

    page=0;

    checkforcurrentweak(weak){
      
      console.log(moment(
        weak, 'MM/DD/YYYY').startOf('week').format('MM/DD/YYYY').toString()==moment().startOf('week').format('MM/DD/YYYY'))
      if(moment(weak, 'MM/DD/YYYY').startOf('week').format('MM/DD/YYYY').toString()+""==moment().startOf('week').format('MM/DD/YYYY'))
       {
        return true;
       }
       else
        return false;

    }
    weak_list_group:any=[]

    get_distinct_week(){

      this.prediction_list_all_lane.sort(this.sortByPropertyas("Prediction for Week"));

      var weak_list = this.prediction_list_all_lane
      .map((item) => item['Prediction for Week bk'])
      .filter(
          (value, index, current_value) => current_value.indexOf(value) === index
      );

      this.weak_list_group = weak_list.map( function(e,i){ 
        return i%3===0 ? weak_list.slice(i,i+3) : null; 
   }).filter(function(e){ return e; });
      console.log(weak_list);

      
      weak_list=weak_list;
      var currentweek = moment().startOf('week');
        console.log(currentweek.format('M/D/YYYY'))
      var index= weak_list.indexOf(currentweek.format('M/D/YYYY'))
      var index=index+1;
      console.log(index)
      if(index>0)
      {
        if((index/3)>0)
        {
          this.page=  parseInt((index/3).toFixed(0));

        }
        else{
          this.page=(index/3);
        }

      }
      this.page=this.page-1;
      console.log(this.page);

      console.log(this.weak_list_group[this.page]);

    }

    get_data__for_filtered_week(weak){
      var alllane= this.prediction_list_all_lane.filter(function(item:any){return item['Prediction for Week bk']===weak})
  

      // .sortByProperty()
      //alllane.sort(this.sortByProperty("Predictions Upper (Consensus Forecast)"));


      var lanes:any=[];
      this.selectedItems.forEach(element => {
        
        var obj= alllane.filter(function(item:any){return item['Lane']===element})
        if(obj.length>0)
         lanes.push(obj[0]);

      });
   

      // console.log(weak);
      // console.log(alllane);

      
      return lanes;
    }
    getfilteredlane()
    { 
      this.lanelist = this.prediction_list_all_lane
      .map((item) => item.Lane)
      .filter(
          (value, index, current_value) => current_value.indexOf(value) === index
      );
      console.log(this.lanelist);
    }

    monthly:any;
    selectdaterange(k){
      this.selecteddaterange=k;
      this.refresh();
  
    }
    allocationnotif="Using default allocation for this lane.please update partner allocation in partner lane config file";
    msgflag=false;
    network_lane_backlog:any=[];
    network_lane:any=[];
    
    selectlane(lane,week ){
  
      // this.networkflag=false;
      // this.user.lane=lane;
      //this.setorg()
      
        var currentweek = moment().startOf('week');
        console.log(currentweek.format('MM/DD/YYYY'))
 
        
        var sweek=moment(week,'MM/DD/YYYY');
        console.log(sweek.format('MM/DD/YYYY'));

        if(currentweek.isSameOrAfter(sweek))
          this.router.navigateByUrl('partnerdemand/'+week.replaceAll('/','-')+'/'+lane)

    }
    
    getlane(lane)
    {
      var lane= this.network_lane.filter(function(item:any){return item.Lane===lane})
  
      // //console.log(lane);
      return lane;
    }
    getlanePartner(partner,lane)
    {
      var lane= this.network_lane.filter(function(item:any){return item.PARTNER===partner&&item.Lane===lane})
  
   
      return lane;
    }
    sortByProperty(property){  
      return function(b,a){  
         if(a[property] > b[property])  
            return 1;  
         else if(a[property] < b[property])  
            return -1;  
     
         return 0;  
      }  
   }
   sortByPropertyas(property){  
    return function(a,b){  
       if(a[property] > b[property])  
          return 1;  
       else if(a[property] < b[property])  
          return -1;  
   
       return 0;  
    }  
  }
   
    getlanePartnertotalmoved(partner)
    {
      var lane= this.network_lane.filter(function(item:any){return item.PARTNER===partner})
      var total=0 
      lane.forEach(element => {
        
        total=total+element.COB_WEIGHT_CHARGEABLE;
       });
       return total;
    }
  
    getlanetotalmoved(lane)
    {
      var lane= this.network_lane.filter(function(item:any){return item.Lane===lane})
      var total=0 
      lane.forEach(element => {
        
        total=total+element.COB_WEIGHT_CHARGEABLE;
       });
       return total;
    }
    getlanbacklog(lane,partner){
      return this.network_lane_backlog.filter(function(item:any){return item.Lane===lane&&item.Lane===lane})
  
    }
    getpartnerlist(partner){
      var lane= this.network_lane.filter(function(item:any){return item.PARTNER===partner})
      lane.sort(this.sortByProperty("COB_WEIGHT_CHARGEABLE"));
      console.log(lane);
      return lane;
    }
    getpartnerlist_backlog(partner,lane){
      var k =this.network_lane_backlog.filter(function(item:any){return item.PARTNER===partner&&item.Lane===lane})
      if(k.length>0)
       return k[0].REC
      else
        return 0
    }
    getpartnerlist_backlog_booked(partner,lane){
      var k =this.network_lane_backlog.filter(function(item:any){return item.PARTNER===partner&&item.Lane===lane})
      if(k.length>0)
       return k[0].Booked
      else
        return 0
    }
    dpartnerlist:any=[]
    selectedpartner=""
    refresh()
    {
      this.list2=[];
      this.resultdata = {
        partner_date:[],
        partner:[],
        date:[],
        total:{"df_total_recepit": 120184.5, "df_total_booked": 120184.5,"df_total_cob": 120184.5},
        week_snap:[],
        partner_config:[],
        alldate:[],
        sl_date:[],
        sl_partner_Date:[]
    
      }
      this.user.startdate=this.datelist[this.selecteddaterange].startdate;
      this.user.enddate=this.datelist[this.selecteddaterange].enddate;
  
      // this.week=[];
      this.msgflag=false;
      // this.LineChartdata_13week.dataTable=[];
      // this.backlog_lane=[{"Lane":"HKG-AMS","PARTNER":"DBS","COB_WEIGHT_CHARGEABLE":14342407.0,"COB":39047.0,"REC":29133.5,"Booked":9913.5},{"Lane":"HKG-AMS","PARTNER":"DHL","COB_WEIGHT_CHARGEABLE":4356299.0,"COB":156658.5,"REC":70434.5,"Booked":86224.0},{"Lane":"HKG-AMS","PARTNER":"EI","COB_WEIGHT_CHARGEABLE":4569421.0,"COB":3578.0,"REC":0.0,"Booked":3578.0}];
      // //console.log(this.backlog_lane);          
     
      this.service.postData(this.user, 'get_demand_sensing_new').then((result) => {
        //console.log(result);          
      var temp:any=result;
      this.list2=temp.data;
      if(this.list2.length>0){
     //  //console.log(this.list);
   
       //console.log(this.list2);
       this.resultdata.partner_config=JSON.parse(this.list2[0]);
       this.resultdata.partner_config=this.resultdata.partner_config.filter(function(item:any){return item.Partner!=null})
  
       this.resultdata.date=JSON.parse(this.list2[2]);
       this.resultdata.partner_date=JSON.parse(this.list2[1]);
       this.resultdata.sl_date=JSON.parse(this.list2[7]);
       this.resultdata.sl_partner_Date=JSON.parse(this.list2[8]);
  
       this.shipeerdata=JSON.parse(this.list2[11]);
       this.week=JSON.parse(this.list2[10]);
       this.monthly=JSON.parse(this.list2[15]);
  
       this.week.reverse()
       //console.log(this.monthly);
       
       this.resultdata.total.df_total_booked=0;
       this.resultdata.total.df_total_recepit=0;
       this.resultdata.total.df_total_cob=0
       this.resultdata.date.forEach(element => {
         this.resultdata.total.df_total_booked=this.resultdata.total.df_total_booked+element.COB_WEIGHT_CHARGEABLE_y;
         this.resultdata.total.df_total_cob=this.resultdata.total.df_total_cob+element.COB_WEIGHT_CHARGEABLE;
         this.resultdata.total.df_total_recepit=this.resultdata.total.df_total_recepit+element.COB_WEIGHT_CHARGEABLE_x;
       });
       // this.resultdata.total=JSON.parse(this.list[2]);
       this.resultdata.partner=JSON.parse(this.list2[3]);
       this.resultdata.week_snap=JSON.parse(this.list2[4]);
       this.resultdata.alldate=JSON.parse(this.list2[6]);
       // this.resultdata.partner_config=JSON.parse(this.list2[5]);
       //console.log(this.resultdata);
  
       if(this.resultdata.partner_config.length>0&&this.resultdata.partner_config[0].BaseRate==0)
       {
        this.msgflag=true;
       }
       if(this.resultdata.date.length>0)
       {
        this.backlog_lane=[]
        this.service.postData(this.user, 'get_demand_sensing_network').then((result) => {
          var res:any=result
          this.backlog_lane=JSON.parse(res.lane) 
          this.network_lane=JSON.parse(res.df_network_cob)   
          this.network_lane_backlog=JSON.parse(res.network)   
    
          this.dpartnerlist = this.network_lane
          .map((item) => item.PARTNER)
          .filter(
              (value, index, current_value) => current_value.indexOf(value) === index
          );
          this.selectedpartner=this.dpartnerlist[0];
       
  
          this.backlog();
          this.calallocations()
          this.drawgraphs();
          // this.msgflag=true;
  
        });
        
   
       }
       
   
      }
  
    });
  
    }
  
    total_cob_backlog_pichart:any;
    total_booked_backlog_pichart:any;
    total_rec_backlog_pichart:any;
  
    total_cob_backlog=0;
    total_booked_backlog=0;
    total_rec_backlog=0;
    backlog_flag=1;
    setbacklog(i){
      this.backlog_flag=i;
    }
    networkflag=true;
    backlog(){
  
      this.total_cob_backlog=0;
      this.total_booked_backlog=0;
      this.total_rec_backlog=0;
      
      this.backlog_lane.forEach(element => {
  
        this.total_booked_backlog=this.total_booked_backlog+element.Booked;
        this.total_cob_backlog=this.total_cob_backlog+element.COB;
        this.total_rec_backlog=this.total_rec_backlog+element.REC;
  
      });
  
      var daydonat_cob = {
        chartType: 'PieChart',
        dataTable: [],
         options: {
          options: {
    
            title: 'Total Backlog',
            
          },
          pieSliceTextStyle: {
            color: 'black',
            fontSize:11
          },
          
          pieStartAngle: 180,
  
          legend:'none',
          colors: ['#D1C4E9','#B3E5FC','#D7CCC8','#F48FB1']
          ,
          'chartArea': {'width': '100%', 'height': '90%'},
  
        height:150,
        }
      }
  
       var temp=[];
       temp.push(['Partner','COB Backlog'])
  
  
       this.backlog_lane.forEach(element => {
  
               temp.push([element.PARTNER,element.COB]);
       });
  
       daydonat_cob.dataTable=temp;
       //console.log(daydonat_cob.dataTable)
       this.total_cob_backlog_pichart=daydonat_cob;
  
  
       var daydonat_booked = {
        chartType: 'PieChart',
        dataTable: [],
         options: {
          options: {
    
            title: 'Total Backlog',
            
          },
          pieSliceTextStyle: {
            color: 'black',
            fontSize:11
          },
          
          pieStartAngle: 180,
  
          legend:'none',
          colors: ['#D1C4E9','#B3E5FC','#D7CCC8','#F48FB1']
          ,
          'chartArea': {'width': '100%', 'height': '90%'},
  
        height:150,
        }
      }
  
       var temp=[];
       temp.push(['Partner','Todate Backlog'])
  
  
       this.backlog_lane.forEach(element => {
         if(element.Booked>0)
               temp.push([element.PARTNER,element.Booked]);
       });
  
       daydonat_booked.dataTable=temp;
       //console.log(daydonat_booked.dataTable)
       this.total_booked_backlog_pichart=daydonat_booked;
  
       var daydonat_rec = {
        chartType: 'PieChart',
        dataTable: [],
         options: {
          options: {
    
            title: 'Total Backlog',
            
          },
          pieSliceTextStyle: {
            color: 'black',
            fontSize:11
          },
          
          pieStartAngle: 180,
  
          legend:'none',
          colors: ['#D1C4E9','#B3E5FC','#D7CCC8','#F48FB1']
          ,
          'chartArea': {'width': '100%', 'height': '90%'},
  
        height:150,
        }
      }
  
       var temp=[];
       temp.push(['Partner','Todate backlog'])
  
  
       this.backlog_lane.forEach(element => {
  
              if(element.REC>0)
                 temp.push([element.PARTNER,element.REC]);
       });
  
       daydonat_rec.dataTable=temp;
       //console.log(daydonat_rec.dataTable)
       this.total_rec_backlog_pichart=daydonat_rec;
    }
    dateflag='c'
    datelist=[];
     selectedDate(value: any, datepicker?: any) {
      // this is the date  selected
      //console.log(value);
      // any object can be passed to the selected event and it will be passed back here
      datepicker.start = value.start.startOf('week');
      datepicker.end = value.end.endOf('week');
  
  
   
      // use passed valuable to update state
      this.daterange.start =value.start.startOf('week').format('MM/DD/YYYY');
      this.daterange.end = value.end.endOf('week').format('MM/DD/YYYY');
      this.daterange.label = value.label;
  
      //multiple week logic
  
  
      var startdate=value.start.startOf('week');
      var endDate=value.end.endOf('week');
      var totalDays = endDate.diff(startdate, 'days');
  
      //console.log(startdate.format('MM/DD/YYYY'),endDate.format('MM/DD/YYYY'),totalDays)
      this.datelist=[];
      for(var i=0;i<(totalDays/7);i++)
      {
        // //console.log(startdate.format('MM/DD/YYYY'))
            var startdates=startdate.clone().add(i*7, 'days').format('MM/DD/YYYY');
              console.log(startdate.format('MM/DD/YYYY'))
              console.log(startdate.clone().add(i*6, 'days').format('MM/DD/YYYY'),moment().format('MM/DD/YYYY'),startdate.clone().add(i*6, 'days').isBefore(moment()))
              var  endDates=startdate.clone().add(i*7, 'days').endOf('week').format('MM/DD/YYYY');
            var dateflag;
              if(moment().isSameOrAfter(startdate.clone().add(i*7, 'days'))&&((moment()).isSameOrBefore(startdate.clone().add(i*7, 'days').endOf('week'))))
              {
                dateflag='c'
              }else{
                dateflag='o'
              }
               //var str=endDate.startOf('week');
            //  //console.log(i,startdate.format('MM/DD/YYYY'),endDate.format('MM/DD/YYYY'))
              this.datelist.push({'startdate':startdates,'enddate':endDates,'flag':dateflag});
        
  
      }
  
      console.log(this.datelist)
      // // if(startdate==startdate1)
      // // {
  
      // //   this.datelist.push({'startdate':value.start.startOf('week').format('MM/DD/YYYY'),'enddate':value.start.endOf('week').format('MM/DD/YYYY')});
      // //   // this.user.startdate=this.daterange.start;
      // //   // this.user.enddate=this.daterange.end;
    
      // // }
      // // else{
      // //     var enddate=value.start.endOf('week');
      // //     var enddate1=value.start.endOf('week');
      // //     var nextstartweek=enddate.add(1, 'days');
      // //     var nextendweek=nextstartweek.endOf('week');
      // //    while(nextstartweek!=startdate1)
      // //     {
      // //       this.datelist.push({'startdate':nextstartweek,'enddate':nextendweek});
      // //     }
  
      // // }
      // var enddate=value.start.endOf('week');
      // this.datelist.push({'startdate':startdate.format('MM/DD/YYYY'),'enddate':enddate.format('MM/DD/YYYY')});
      // var nextstartweek=enddate.add(1, 'days')
      // var nextenddate=nextstartweek.endOf('week');
  
      // while(nextstartweek<startdate1)
      // {
  
      //     this.datelist.push({'startdate':nextstartweek.format('MM/DD/YYYY'),'enddate':nextenddate.format('MM/DD/YYYY')});
      //     nextstartweek=nextenddate.add(1, 'days')
      //     nextenddate=nextstartweek.endOf('week');
        
      // }
      // //console.log(this.datelist)
  
      //this.updateDateRange(value.start.startOf('week'),value.end.endOf('week'))
  
      // datepicker.setStartDate(value.start.startOf('week'))
      // datepicker.setEndDate(value.end.endOf('week'))
  
  
      this.user.startdate=this.daterange.start;
      this.user.enddate=this.daterange.end;
    //  this.datelist=[];
      //this.datelist.push({'startdate':this.user.startdate,'enddate':this.user.enddate});
  
      this.refresh();
  
    }
  
    selecteddaterange=0;
  
    select(event) {
      //console.log(event);
      if(event.selectedRowValues.length>0&&event.row<this.resultdata.date.length)
      {
         this.selectedday=event.row;
        // this.smonthasslane=event.selectedRowValues[0]
        // this.filterlistlane()
        var cchart = {
          chartType: 'ColumnChart',
          dataTable: [],
           options: {
            options: {
      
              title: 'Past week moving averages',
              
            },
            groupWidth:40,
            hAxis: {
              baselineColor: 'none',
              ticks: []
            },
            vAxis: {
              baselineColor: 'none',
              ticks: []
            },
          //   vAxis: { textPosition: 'none', gridlines: {
          //     color: 'transparent'
          // } },
          legend:'none',
  
          'chartArea': {'width': '80%', 'height': '80%'},
  
            colors: ['#81D4FA']
            ,
          height:180,
          }
        } 
  
        var daydonat = {
          chartType: 'PieChart',
          dataTable: [],
           options: {
            options: {
      
              title: 'Total Booked',
              
            },
            pieSliceTextStyle: {
              color: 'black',
              fontSize:11
            },
            
            pieStartAngle: 180,
    
            legend:'none',
            colors: ['#D1C4E9','#B3E5FC','#D7CCC8','#F48FB1']
            ,
            'chartArea': {'width': '100%', 'height': '90%'},
    
          height:150,
          }
        }
    
         var temp=[];
         temp.push(['Partner','Capacity'])
  
         var dpartner = this.resultdata.partner_date
         .map((item) => item.PARTNER)
         .filter(
             (value, index, current_value) => current_value.indexOf(value) === index
         );
     var ddate = this.resultdata.partner_date
          .map((item) => item.Date)
          .filter(
              (value, index, current_value) => current_value.indexOf(value) === index
          );
         dpartner.forEach(element => {
  
          //console.log(element,this.resultdata.date[this.selectedday].Date)
          
          ;
                var array=this.getkg(element,this.resultdata.date[this.selectedday].Date)
                if(array.length>0)
                 temp.push([element,array[0].COB_WEIGHT_CHARGEABLE]);
                else
                  temp.push([element,0]);
         });
  
         daydonat.dataTable=temp;
         //console.log(daydonat.dataTable)
         this.selecteddaydonat=daydonat;
  
         var daydonat_res = {
          chartType: 'PieChart',
          dataTable: [],
           options: {
            options: {
      
              title: 'Total Booked',
              
            },
            pieSliceTextStyle: {
              color: 'black',
              fontSize:11
            },
            
            pieStartAngle: 180,
    
            legend:'none',
            colors: ['#D1C4E9','#B3E5FC','#D7CCC8','#F48FB1']
            ,
            'chartArea': {'width': '100%', 'height': '90%'},
    
          height:150,
          }
        }
  
    
         var temp=[];
         temp.push(['Partner','Capacity'])
  
         dpartner.forEach(element => {
  
          //console.log(element,this.resultdata.date[this.selectedday].Date)
          
          ;
                var array=this.getkg(element,this.resultdata.date[this.selectedday].Date)
                if(array.length>0)
                 temp.push([element,array[0].COB_WEIGHT_CHARGEABLE_x]);
                else
                  temp.push([element,0]);
         });      
  
         daydonat_res.dataTable=temp;
         this.selecteddaydonat_res=daydonat_res;
  
         var daydonat_booked=JSON.parse(JSON.stringify(daydonat_res));
         var temp=[];
         temp.push(['Partner','Capacity'])
  
         dpartner.forEach(element => {
  
          //console.log(element,this.resultdata.date[this.selectedday].Date)
          
          ;
                var array=this.getkg(element,this.resultdata.date[this.selectedday].Date)
                if(array.length>0)
                 temp.push([element,array[0].COB_WEIGHT_CHARGEABLE_y]);
                else
                  temp.push([element,0]);
         });      
  
         daydonat_booked.dataTable=temp;
         this.selecteddaydonat_booked=daydonat_booked;
         //sl
  
       
         var temp=[];
      temp.push(["Title","Value"])
      // var lastweek=this.resultdata.week_snap[0]['Observed Chargeable Weight'];
      // var pred=this.resultdata.week_snap[0]['Predicted Chargeable Weight'];
      // if(this.resultdata.week_snap[0]['Observed Chargeable Weight']==0)
      //   lastweek=null
      // if(this.resultdata.week_snap[0]['Predicted Chargeable Weight']==0)
      //   pred=null
  
      temp.push(["Total Booked",this.resultdata.date[this.selectedday].COB_WEIGHT_CHARGEABLE])
      temp.push(["Total Received",this.resultdata.date[this.selectedday].COB_WEIGHT_CHARGEABLE_x])
  
     
      var clchart =JSON.parse(JSON.stringify(cchart)) 
      clchart.options.height="140"
      clchart.dataTable=temp;
      this.selecteddayBar=clchart;
  
  
      var temp=[];
  
         temp.push(['Service Level','Capacity'])
  
         var pidata= this.barchart_sl.dataTable[this.selectedday+1];
  
  
  
         var kn=1;
         //console.log(this.barchart_sl.dataTable[0])
         pidata.slice(1,pidata.length-1).forEach(element => {
          
          //console.log(element)
          temp.push([this.barchart_sl.dataTable[0][kn],element])
           kn=kn+1;
         });
         //console.log(temp);
  
     
  
  
          var sl_pi_selected = {
            chartType: 'PieChart',
            dataTable: [],
            options: {
              options: {
        
                title: 'Total Booked',
                
              },
              pieSliceTextStyle: {
                color: 'black',
                fontSize:11
              },
              
              pieStartAngle: 180,
  
              legend:'none',
              colors:  ['#9CCC65','#FFD54F','#FF8A65']
              ,
              'chartArea': {'width': '100%', 'height': '90%'},
  
            height:150,
            }
          }
  
          
          sl_pi_selected.dataTable=temp;
          this.selecteddaydonat_sl=sl_pi_selected;
          //console.log(this.selecteddaydonat_sl);
  
  
          // var sll = this.resultdata.sl_partner_Date
          // .map((item) => item['Service Level'])
          // .filter(
          //     (value, index, current_value) => current_value.indexOf(value) === index
          // );
          //   //
          //   var date=this.resultdata.date[this.selectedday].Date;
  
          //   var sls_date=this.resultdata.sl_date.filter(function(item:any){
          //     return item.Date===date})
  
          //     this.sl_partnerlist=[]
          //     // //console.log(sls_date)
          //     sll.forEach(element => {
              
          //       var total_sl="";
          //           var bchartsmall = {
          //        chartType: 'PieChart',
          //        dataTable: [],
          //         options: {
          //          options: {
            
          //            title: 'Total Booked',
                    
          //          },
          //          pieSliceTextStyle: {
          //            color: 'black',
          //            fontSize:8
          //          },
                  
          //          pieStartAngle: 180,
          
          //          legend:'none',
          //          colors:  ['#D1C4E9','#B3E5FC','#D7CCC8','#F48FB1']
          //          ,
          //          'chartArea': {'width': '100%', 'height': '90%'},
          
          //        height:180,
          //        }
          //      }
              
          //      var partlist_sl:any=sls_date.filter(function(item:any){return item['Service Level']===element})
  
          //      var temp=[];
          //      temp.push(['Partner','Value'])
              
          //      partlist_sl.forEach(kelement => {
          //       temp.push([kelement.PARTNER,kelement.COB_WEIGHT_CHARGEABLE])
          //       total_sl=total_sl+kelement.COB_WEIGHT_CHARGEABLE
                
          //      });
  
          //      var graphs=JSON.parse(JSON.stringify(bchartsmall));
          //      graphs.dataTable=temp;
          //      this.sl_partnerlist.push({"sl":element,"graph":graphs,"total STD":total_sl})
              
          //     });   
          //     //console.log(this.sl_partnerlist);
  
          
          var dpartner = this.resultdata.sl_date
          .map((item) => item.PARTNER)
          .filter(
              (value, index, current_value) => current_value.indexOf(value) === index
          );
  
          //service level by partner distribution
          var date=this.resultdata.date[this.selectedday].Date;
  
          this.sl_partnerlist=[];
  
          var sls_date=this.resultdata.sl_date.filter(function(item:any){
            return item.Date===date})
  
            //console.log(sls_date)
            this.sl_partnerlist=[];
            dpartner.forEach(element => {
              var total_sl="";
                  var bchartsmall = {
              chartType: 'PieChart',
              dataTable: [],
                options: {
                options: {
          
                  title: 'Total Booked',
                  
                },
                pieSliceTextStyle: {
                  color: 'black',
                  fontSize:8
                },
                
                pieStartAngle: 180,
        
                legend:'none',
                colors:  ['#9CCC65','#FFD54F','#FF8A65']
                ,
                'chartArea': {'width': '100%', 'height': '90%'},
        
              height:90,
              }
            }
            
            var sllist_p:any=sls_date.filter(function(item:any){return item.PARTNER===element})
              
            var sl = ['STD','DEF','EXP']
            //  var sllist:any=sls_date.filter(function(item:any){return item.PARTNER===element})
            var sllist=[] 
            sl.forEach(element => {
              var sllist_t:any=sllist_p.filter(function(item:any){return item['Service Level']===element})
              if(sllist_t.length>0)
                sllist.push(sllist_t[0])
              else
              {
                var obj ={
                  "Date": this.resultdata.date[this.selectedday],
                  "PARTNER": 0,
                  "Service Level":element,
                  "COB_WEIGHT_CHARGEABLE_x": 0,
                  "COB_WEIGHT_CHARGEABLE_y": 0,
                  "COB_WEIGHT_CHARGEABLE": 0
              }
                sllist.push(obj)
              }
            });
  
  
            //console.log(sllist);
            var temp=[];
            temp.push(['Service Level','Value'])
            sllist.forEach(element => {
              temp.push([element['Service Level'],element.COB_WEIGHT_CHARGEABLE])
              total_sl=total_sl+element.COB_WEIGHT_CHARGEABLE
              
            });
              var graphs=JSON.parse(JSON.stringify(bchartsmall));
              graphs.dataTable=temp;
              this.sl_partnerlist.push({"sl":element,"graph":graphs,"total STD":total_sl})
            });
            //console.log(this.sl_partnerlist);
  
          }
          else{
            alert("Can't select this day. because no data available for this day");
          }
    
  }
    calallocations(){
      this.allocation.totalallocation = 0;
      this.allocation.flex=0;
      this.allocation.base=0;
      this.resultdata.partner_config.forEach(element => {
  
        this.allocation.flex=this.allocation.flex+element.Flex;
        this.allocation.base=this.allocation.base+element.Baseallocation;
      });
      this.allocation.totalallocation = (this.allocation.flex + this.allocation.base);
  
    }
  
    barchart:any;
    barchart_sl:any;
    weekpred:any;
  
    total_moved_available:any;
    LineChartdata_13week:any;
    LineChartdata_13week_3b18:any;
    LineChartdata_monthly:any;
    LineChartdata_monthly_3b18:any;
  
    LineChartdata_13week_receipt;
    drawgraphs (){
  
  
      //13 week graph
  
      var LineChartdata = {
        chartType: 'ComboChart',
        dataTable: temp,
         options: {
          options: {
    
            title: "Last 13 week's actual demand and Weekly Trends",
            
          },
          hAxis: {  gridlines: {
            color: 'transparent'
           }},
           vAxis :{
            gridlines: {
              color: 'transparent'
             }
           },
           
          pointSize:3,
          legend: { position: 'top', alignment: 'center' },
          seriesType: 'bars',
          series: {3: {type: 'line',targetAxisIndex:0},4: {type: 'line',targetAxisIndex:0,lineDashStyle: [10, 2],color:"blue"}},        
          
          colors: ['#AED6F1','#FAD7A0','#7FB3D5','#2C3E50']
          ,
        height:440,
        }
    
      }
  
      var temp=[];
      temp.push(['Week','Moving average past 2 week','Moving average past 4 week','Moving average past Quarter','Week Total Tonnage',{role:'annotation'},{label: 'Ocean Week Total Tonnage', type: 'number'}])
  
      this.week.forEach(element => {
  
        // var week= (new Date(element.Week).getMonth()+1)+'/'+(new Date(element.Week).getDate()+1)+'/'+new Date(element.Week).getFullYear();
        var utcdate=new Date(element.Week).toLocaleString('en-US', { timeZone: 'UTC' });
       var week=utcdate.split(",")[0]
  
        var mavg2=0
        var mavg4=0;
        var mavg3=0;
         var ocean_weekly=null
        if(element['Moving Avg 2wks']!=null)
          mavg2=element['Moving Avg 2wks']
        if(element['Moving Avg 4wks']!=null)
          mavg4=element['Moving Avg 4wks']
        if(element['Moving Avg 3mnths']!=null)
          mavg3=element['Moving Avg 3mnths']
  
        if(element['OCEAN_WEIGHT_CHARGEABLE_y']!=null)
           ocean_weekly=element['OCEAN_WEIGHT_CHARGEABLE_y']
  
        
          
        temp.push([week,mavg2,mavg4,mavg3,element['Observed Chargeable Weight'],element['Observed Chargeable Weight'],ocean_weekly])
         
      });
  
      //console.log(temp);
      LineChartdata.dataTable=temp;
      this.LineChartdata_13week=LineChartdata;
      //console.log(this.LineChartdata_13week)
  
      //3ba8
  
          //13 week graph
  
         var  LineChartdatak = {
            chartType: 'ComboChart',
            dataTable: temp,
             options: {
              options: {
        
                title: "Last 13 week's actual demand and Weekly Trends",
                
              },
              hAxis: {  gridlines: {
                color: 'transparent'
               }},
               vAxis :{
                gridlines: {
                  color: 'transparent'
                 }
               },
               
              pointSize:3,
              legend: { position: 'top', alignment: 'center' },
              seriesType: 'bars',
              targetAxisIndex:0,
              // series: {0: {type: 'bars',targetAxisIndex:1},1: {type: 'bars',targetAxisIndex:1},2: {type: 'bars',targetAxisIndex:1},3: {type: 'line',targetAxisIndex:0},4: {type: 'line',targetAxisIndex:0,lineDashStyle: [10, 2],color:"blue"},5: {type: 'line',targetAxisIndex:0,lineDashStyle: [10, 2],color:"red"},6: {type: 'line',targetAxisIndex:0,lineDashStyle: [10, 2],color:"green"}},
              series: {0: {type: 'bars',targetAxisIndex:1},1: {type: 'line',targetAxisIndex:0},2: {type: 'line',targetAxisIndex:0,lineDashStyle: [10, 2],color:"blue"},3: {type: 'line',targetAxisIndex:0,lineDashStyle: [10, 2],color:"red"}},        
              
              colors: ['#F5B7B1','#2C3E50']
              ,
            height:440,
            }
        
          }
      
          var temp=[];
          temp.push(['Week','% Variance','Week Total Tonnage',{role:'annotation'},{label: 'Ocean Week Total Tonnage', type: 'number'},{label: 'Planned Weight Kg', type: 'number'}])
      
          this.week.forEach(element => {
      
            // var week= (new Date(element.Week).getMonth()+1)+'/'+(new Date(element.Week).getDate()+1)+'/'+new Date(element.Week).getFullYear();
            var utcdate=new Date(element.Week).toLocaleString('en-US', { timeZone: 'UTC' });
            var week=utcdate.split(",")[0]          
            var mavg2=0
            var mavg4=0;
            var mavg3=0;
             var ocean_weekly=null
             var receipt_weekly=null
             var total_weekly=null
            if(element['Variance to 3B18']!=null)
              mavg2=element['Variance to 3B18']*100
  
            // if(element['Moving Avg 2wks']!=null)
            //   mavg2=element['Moving Avg 2wks']
            if(element['Moving Avg 4wks']!=null)
              mavg4=element['Moving Avg 4wks']
            if(element['Moving Avg 3mnths']!=null)
              mavg3=element['Moving Avg 3mnths']
      
            if(element['OCEAN_WEIGHT_CHARGEABLE_y']!=null)
               ocean_weekly=element['OCEAN_WEIGHT_CHARGEABLE_y']
            
            if(element['Receipt_Weight']!=null)
               receipt_weekly=element['Receipt_Weight']
            if(element['total_weight_kg']!=null)
               total_weekly=element['total_weight_kg']
      
            
              
            temp.push([week,mavg2,element['Observed Chargeable Weight'],element['Observed Chargeable Weight'],ocean_weekly,total_weekly])
    
             
          });
      
          //console.log(temp);
          LineChartdatak.dataTable=temp;
          this.LineChartdata_13week_3b18=LineChartdatak;
          //console.log(this.LineChartdata_13week)
  
              //total weight kg
  
          //13 week graph
  
          var  LineChartdatakt = {
            chartType: 'ComboChart',
            dataTable: temp,
             options: {
              options: {
        
                title: "Last 13 week's actual demand and Weekly Trends",
                
              },
              hAxis: {  gridlines: {
                color: 'transparent'
               }},
               vAxis :{
                gridlines: {
                  color: 'transparent'
                 }
               },
               
              pointSize:3,
              legend: { position: 'top', alignment: 'center' },
              seriesType: 'bars',
              targetAxisIndex:0,
              // series: {0: {type: 'bars',targetAxisIndex:1},1: {type: 'bars',targetAxisIndex:1},2: {type: 'bars',targetAxisIndex:1},3: {type: 'line',targetAxisIndex:0},4: {type: 'line',targetAxisIndex:0,lineDashStyle: [10, 2],color:"blue"},5: {type: 'line',targetAxisIndex:0,lineDashStyle: [10, 2],color:"red"},6: {type: 'line',targetAxisIndex:0,lineDashStyle: [10, 2],color:"green"}},
              series: {0: {type: 'bars',targetAxisIndex:1},1: {type: 'line',targetAxisIndex:0},2: {type: 'line',targetAxisIndex:0,lineDashStyle: [10, 2],color:"blue"},3: {type: 'line',targetAxisIndex:0,lineDashStyle: [10, 2],color:"red"}},        
              
              colors: ['#F5B7B1','#2C3E50']
              ,
            height:440,
            }
        
          }
      
          var temp=[];
          temp.push(['Week','% Variance','Week Total Tonnage',{role:'annotation'},{label: 'Ocean Week Total Tonnage', type: 'number'},{label: 'Receipts Weight Kg', type: 'number'}])
      
          this.week.forEach(element => {
      
            var utcdate=new Date(element.Week).toLocaleString('en-US', { timeZone: 'UTC' });
            var week=utcdate.split(",")[0]          
            
            var mavg2=0
            var mavg4=0;
            var mavg3=0;
             var ocean_weekly=null
             var receipt_weekly=null
             var total_weekly=null
            if(element['Variance to Receipts']!=null)
              mavg2=element['Variance to Receipts']*100
  
            // if(element['Moving Avg 2wks']!=null)
            //   mavg2=element['Moving Avg 2wks']
            if(element['Moving Avg 4wks']!=null)
              mavg4=element['Moving Avg 4wks']
            if(element['Moving Avg 3mnths']!=null)
              mavg3=element['Moving Avg 3mnths']
      
            if(element['OCEAN_WEIGHT_CHARGEABLE_y']!=null)
               ocean_weekly=element['OCEAN_WEIGHT_CHARGEABLE_y']
            
            if(element['Receipt_Weight']!=null)
               receipt_weekly=element['Receipt_Weight']
            if(element['total_weight_kg']!=null)
               total_weekly=element['total_weight_kg']
      
            
              
            temp.push([week,mavg2,element['Observed Chargeable Weight'],element['Observed Chargeable Weight'],ocean_weekly,receipt_weekly])
    
             
          });
      
  
        //console.log(temp);
        LineChartdatakt.dataTable=temp;
        this.LineChartdata_13week_receipt=LineChartdatakt;
  
  
        //monthly 3b
  
        var  LineChartdatam3b = {
          chartType: 'ComboChart',
          dataTable: temp,
           options: {
            options: {
      
              title: "Last 13 week's actual demand and Weekly Trends",
              
            },
            hAxis: {  gridlines: {
              color: 'transparent'
             }},
             vAxis :{
              gridlines: {
                color: 'transparent'
               }
             },
             
            pointSize:3,
            legend: { position: 'top', alignment: 'center' },
            seriesType: 'bars',
            targetAxisIndex:0,
            // series: {0: {type: 'bars',targetAxisIndex:1},1: {type: 'bars',targetAxisIndex:1},2: {type: 'bars',targetAxisIndex:1},3: {type: 'line',targetAxisIndex:0},4: {type: 'line',targetAxisIndex:0,lineDashStyle: [10, 2],color:"blue"},5: {type: 'line',targetAxisIndex:0,lineDashStyle: [10, 2],color:"red"},6: {type: 'line',targetAxisIndex:0,lineDashStyle: [10, 2],color:"green"}},
            series: {0: {type: 'bars',targetAxisIndex:1},1: {type: 'line',targetAxisIndex:0},2: {type: 'line',targetAxisIndex:0,lineDashStyle: [10, 2],color:"blue"},3: {type: 'line',targetAxisIndex:0,lineDashStyle: [10, 2],color:"red"}},        
            
            colors: ['#F5B7B1','#2C3E50']
            ,
          height:440,
          }
      
        }
    
        var temp=[];
        temp.push(['Week','% Variance','Week Total Tonnage',{role:'annotation'},{label: 'Ocean Week Total Tonnage', type: 'number'},{label: 'Planned Weight Kg', type: 'number'}])
    
        this.monthly.forEach(element => {
    
          // var week= (new Date(element.Week).getMonth()+1)+'/'+(new Date(element.Week).getDate()+1)+'/'+new Date(element.Week).getFullYear();
          var utcdate=new Date(element.Month).toLocaleString('en-US', { timeZone: 'UTC' });
          var week=utcdate.split(",")[0]          
          var mavg2=0
          var mavg4=0;
          var mavg3=0;
           var ocean_weekly=null
           var receipt_weekly=null
           var total_weekly=null
          if(element['Variance to 3B18']!=null)
            mavg2=element['Variance to 3B18']*100
  
          // if(element['Moving Avg 2wks']!=null)
          //   mavg2=element['Moving Avg 2wks']
   
          // if(element['Moving Avg 4wks']!=null)
          //   mavg4=element['Moving Avg 4wks']
          // if(element['Moving Avg 3mnths']!=null)
          //   mavg3=element['Moving Avg 3mnths']
    
          if(element['OCEAN_WEIGHT_CHARGEABLE']!=null)
             ocean_weekly=element['OCEAN_WEIGHT_CHARGEABLE']
          
          if(element['Receipt_Weight']!=null)
             receipt_weekly=element['Receipt_Weight']
          if(element['total_weight_kg']!=null)
             total_weekly=element['total_weight_kg']
                      
          temp.push([week,mavg2,element['WEIGHT_CHARGEABLE'],element['WEIGHT_CHARGEABLE'],ocean_weekly,total_weekly]);
           
        });
    
        //console.log(temp);
        LineChartdatam3b.dataTable=temp;
        this.LineChartdata_monthly_3b18=LineChartdatam3b;
        //console.log(this.LineChartdata_monthly_3b18);
  
        //
  
        var  LineChartdatam = {
          chartType: 'ComboChart',
          dataTable: temp,
           options: {
            options: {
      
              title: "Last 13 week's actual demand and Weekly Trends",
              
            },
            hAxis: {  gridlines: {
              color: 'transparent'
             }},
             vAxis :{
              gridlines: {
                color: 'transparent'
               }
             },
             
            pointSize:3,
            legend: { position: 'top', alignment: 'center' },
            seriesType: 'bars',
            targetAxisIndex:0,
            // series: {0: {type: 'bars',targetAxisIndex:1},1: {type: 'bars',targetAxisIndex:1},2: {type: 'bars',targetAxisIndex:1},3: {type: 'line',targetAxisIndex:0},4: {type: 'line',targetAxisIndex:0,lineDashStyle: [10, 2],color:"blue"},5: {type: 'line',targetAxisIndex:0,lineDashStyle: [10, 2],color:"red"},6: {type: 'line',targetAxisIndex:0,lineDashStyle: [10, 2],color:"green"}},
            series: {0: {type: 'bars',targetAxisIndex:1},1: {type: 'line',targetAxisIndex:0},2: {type: 'line',targetAxisIndex:0,lineDashStyle: [10, 2],color:"blue"},3: {type: 'line',targetAxisIndex:0,lineDashStyle: [10, 2],color:"red"}},        
            
            colors: ['#F5B7B1','#2C3E50']
            ,
          height:440,
          }
      
        }
    
        var temp=[];
        temp.push(['Week','% Variance','Week Total Tonnage',{role:'annotation'},{label: 'Ocean Week Total Tonnage', type: 'number'},{label: 'Receipts Weight Kg', type: 'number'}])
    
        this.monthly.forEach(element => {
    
          var utcdate=new Date(element.Month).toLocaleString('en-US', { timeZone: 'UTC' });
          var week=utcdate.split(",")[0]          
          
          var mavg2=0
          var mavg4=0;
          var mavg3=0;
           var ocean_weekly=null
           var receipt_weekly=null
           var total_weekly=null
          if(element['Variance to Receipts']!=null)
            mavg2=element['Variance to Receipts']*100
  
          // if(element['Moving Avg 2wks']!=null)
          //   mavg2=element['Moving Avg 2wks']
          // if(element['Moving Avg 4wks']!=null)
          //   mavg4=element['Moving Avg 4wks']
          // if(element['Moving Avg 3mnths']!=null)
          //   mavg3=element['Moving Avg 3mnths']
    
          if(element['OCEAN_WEIGHT_CHARGEABLE']!=null)
             ocean_weekly=element['OCEAN_WEIGHT_CHARGEABLE']
          
          if(element['Receipt_Weight']!=null)
             receipt_weekly=element['Receipt_Weight']
          if(element['total_weight_kg']!=null)
             total_weekly=element['total_weight_kg']
    
          
            
          temp.push([week,mavg2,element['WEIGHT_CHARGEABLE'],element['WEIGHT_CHARGEABLE'],ocean_weekly,receipt_weekly])
  
           
        });
    
  
      //console.log(temp);
      LineChartdatam.dataTable=temp;
      this.LineChartdata_monthly=LineChartdatam;
  
      //total moveed vs abailable
  
      var bchart_m = {
        chartType: 'PieChart',
        dataTable: [],
         options: {
          options: {
    
            title: 'Total Booked',
            
          },
          'chartArea': {'width': '80%', 'height': '80%'},
  
          pieHole:0.4,
          pieSliceTextStyle: {
            color: 'black',
            fontSize:9
          },
          
          pieStartAngle: 180,
  
          legend: { position: 'top', alignment: 'center' },
          colors: ['#5C6BC0','#C5CAE9']
          ,
  
        height:140,
        }
      }
  
      var total_moved=0;
      var total_available=0;
  
      this.resultdata.partner.forEach(element => {
        
        total_moved=total_moved+element.COB_WEIGHT_CHARGEABLE;
  
      });
  
       var temp=[];
       temp.push(['Title','Capacity'])
       temp.push(['Moved',total_moved])
       if(this.allocation.totalallocation>=total_moved)
        temp.push(['Total Remaining',(this.allocation.totalallocation-total_moved)])
       else
        temp.push(['Total Remaining',0])
  
       bchart_m.dataTable=temp;
       this.total_moved_available=bchart_m;
  
      var bchart = {
        chartType: 'PieChart',
        dataTable: [],
         options: {
          options: {
    
            title: 'Total Booked',
            
          },
          pieHole:0.4,
          pieSliceTextStyle: {
            color: 'black',
            fontSize:11
          },
          
          pieStartAngle: 180,
  
          legend:'none',
          colors: ['#5C6BC0','#C5CAE9']
          ,
          'chartArea': {'width': '100%', 'height': '90%'},
  
        height:180,
        }
      }
  
       var temp=[];
       temp.push(['Title','Capacity'])
       temp.push(['COB',this.resultdata.total.df_total_cob])
       if(this.resultdata.total.df_total_booked>=this.resultdata.total.df_total_cob)
        temp.push(['Total Remaining',this.resultdata.total.df_total_booked-this.resultdata.total.df_total_cob])
       else
        temp.push(['Total Remaining',0])
   
        //console.log(temp);
       bchart.dataTable=temp;
       this.donatchart_total=JSON.parse(JSON.stringify(bchart));
  
       temp=[];
       temp.push(['Title','Capacity'])
       temp.push(['COB',this.resultdata.total.df_total_cob])
       if(this.resultdata.total.df_total_recepit>=this.resultdata.total.df_total_cob)
        temp.push(['Total Remaining',this.resultdata.total.df_total_recepit-this.resultdata.total.df_total_cob])
       else
        temp.push(['Total Remaining',0])         
   
        bchart.dataTable=temp;
       this.donatchart_total_cob=JSON.parse(JSON.stringify(bchart));;
  
       this.partnergraphlist=[];
       
       this.resultdata.partner.forEach(element => {
  
        var bchart = {
          chartType: 'PieChart',
          dataTable: [],
           options: {
            options: {
      
              title: 'Total Booked',
              
            },
            pieHole:0.4,
            pieSliceTextStyle: {
              color: 'black',
              fontSize:8
            },
            
            pieStartAngle: 180,
    
            legend:'none',
            colors: ['#5C6BC0','#C5CAE9']
            ,
            'chartArea': {'width': '100%', 'height': '90%'},
    
          height:80,
          }
        }
    
         var temp=[];
         temp.push(['Title','Capacity'])
         var booked=element.COB_WEIGHT_CHARGEABLE_y;
         var cob=element.COB_WEIGHT_CHARGEABLE;
         if(element.COB_WEIGHT_CHARGEABLE==null)
            cob=0
  
         if(element.COB_WEIGHT_CHARGEABLE_y==null)
            booked=0
  
         temp.push(['COB',cob])
         if(booked>cob)
          temp.push(['Total Remaining',booked-cob])
         else 
          temp.push(['Total Remaining',0])
         
          bchart.dataTable=temp;
         
         var temp=[];
  
         temp.push(['Title','Capacity'])
  
         temp.push(['COB',cob])
  
        if(element.COB_WEIGHT_CHARGEABLE_x>=cob)
          temp.push(['Total Remaining',element.COB_WEIGHT_CHARGEABLE_x-cob])
        else
          temp.push(['Total Remaining',0])
  
         var bchartb=JSON.parse(JSON.stringify(bchart))
         bchartb.dataTable=temp;
  
         this.partnergraphlist.push({"partner":element.PARTNER,"receipt":element.COB_WEIGHT_CHARGEABLE_x,"booked":booked,"cob":cob,"graph":bchart,"graphb":bchartb})
         //console.log(this.partnergraphlist);
  
       });
  
        //moving average
  
        var cchart = {
          chartType: 'ColumnChart',
          dataTable: [],
           options: {
            options: {
      
              title: 'Past week moving averages',
              
            },
            groupWidth:40,
            hAxis: {
              baselineColor: 'none',
              ticks: []
            },
            vAxis: {
              baselineColor: 'none',
              ticks: []
            },
          //   vAxis: { textPosition: 'none', gridlines: {
          //     color: 'transparent'
          // } },
          legend:'none',
  
          'chartArea': {'width': '80%', 'height': '80%'},
  
            colors: ['#D1C4E9','#B3E5FC','#D7CCC8','#F48FB1']
            ,
          height:180,
          }
        } 
  
        var temp=[];
        if(this.resultdata.week_snap.length>0)
        {
          temp.push(["Week","Chargable Weight"])
          temp.push(["Past 2 Week",this.resultdata.week_snap[0]['Moving Avg 2wks']])
          temp.push(["Past 4 Week",this.resultdata.week_snap[0]['Moving Avg 4wks']])
          temp.push(["Past Quarter",this.resultdata.week_snap[0]['Moving Avg 3mnths']])
          
          cchart.dataTable=temp;
          this.movingbarchart=cchart;
          //console.log(this.movingbarchart)
        }
  
        // var clchart ={
        //   chartType: 'ColumnChart',
  
        //   dataTable: [],
        //    options: {
        //     options: {
      
        //       title: 'Week Prediction',
              
        //     },
        //     vAxis: { textPosition: 'none', gridlines: {
        //       color: 'transparent',baselineColor:'#fff'
        //   } },
        //   hAxis:{baselineColor:'#fff'},
        //   legend:'none',
  
        //   'chartArea': {'width': '80%', 'height': '80%'},
  
        //     colors: ['#ADD8E6','#5D8AA8','#BCD4E6','#6CA0DC','#4B9CD3']
        //     ,
        //   height:180,
        //   }
        // } 
  
  
        var temp=[];
        if(this.resultdata.week_snap.length>0){
          temp.push(["Week","Chargable Weight"])
          var lastweek=this.resultdata.week_snap[0]['Observed Chargeable Weight'];
          var pred=this.resultdata.week_snap[0]['Predicted Chargeable Weight'];
          if(this.resultdata.week_snap[0]['Observed Chargeable Weight']==0)
            lastweek=null
          if(this.resultdata.week_snap[0]['Predicted Chargeable Weight']==0)
            pred=null
    
          temp.push(["Last Week",lastweek])
          temp.push(["Current Week",pred])
          var clchart =JSON.parse(JSON.stringify(cchart)) 
          clchart.dataTable=temp;
          this.weekpred=clchart;
          //console.log(this.weekpred)
      
        }
   
       
  
        //unique partner
        // var sll = this.resultdata.sl_partner_Date
        //       .map((item) => item['Service Level'])
        //       .filter(
        //           (value, index, current_value) => current_value.indexOf(value) === index
        //       );
  
  
        var sll = ['STD','DEF','EXP']
        var dpartner = this.resultdata.partner_date
              .map((item) => item.PARTNER)
              .filter(
                  (value, index, current_value) => current_value.indexOf(value) === index
              );
        var ddate = this.resultdata.partner_date
              .map((item) => item.Date)
              .filter(
                  (value, index, current_value) => current_value.indexOf(value) === index
              );
          var temp=[];
          var k=[];
           k.push('Day')
           dpartner.forEach(element => {
              k.push(element)
           });
           k.push({role:'annotation'})
           temp.push(k)
  
           
           //console.log(ddate);
           var c=0;
           ddate.forEach(element => {
            var j=[];
            j.push(this.weeekday[c]) 
            var total=0;
            dpartner.forEach(pelement => {
              var arra=this.getkg(pelement,element);
              //console.log(arra)
              if(arra.length>0)
               {
                  j.push(arra[0].COB_WEIGHT_CHARGEABLE)
                  total=total+arra[0].COB_WEIGHT_CHARGEABLE;
               }
               else
                 j.push(0) 
             });
             c=c+1;
             j.push(total)
            
             temp.push(j);
           });
           
  
           if(ddate.length==7&&this.resultdata.date[0].Date>this.resultdata.date[6].Date)
           {
  
            //console.log(temp)
            
            var tempobj =temp[7];
            // temp.unshift(tempobj);
            temp.splice(1, 0, tempobj);
  
            temp.splice(-1);
            var m=0;
            for(var m=1;m<=7;m++)
            {
              //console.log(this.weeekday[m])
  
                temp[m][0]=this.weeekday[m-1];
                //console.log(temp[m][0])
            }
            //console.log(temp)
  
           }
           else{
  
           
           for(var i=ddate.length;i<7;i++)
           {
            var k=[];
              k.push(this.weeekday[i])
             dpartner.forEach(pelement => {
               k.push(0)
             });
             k.push(0)
            temp.push(k);
  
           }
          }
  
  
  
  
  
           var barchart = {
            chartType: 'BarChart',
            dataTable: temp,
             options: {
              options: {
        
                title: 'Monthly Spend Variance',
                
              },
              annotations: {
                textStyle: {
                color:'black'
                }
              },
              legend: { position: 'top', alignment: 'center' },
              isStacked:true,
  
              // bar: { groupWidth: "50%" },
              'chartArea': {'width': '75%', 'height': '75%'},
  
              vAxis: {  gridlines: {
                color: 'transparent'
              },
            },
            
            hAxis: {  gridlines: {
              color: 'transparent'
             },
             textPosition: 'none' 
            },
        
          
              // isStacked:"true",
              
              // vAxes: {
              //   // Adds titles to each axis.
              //   0: {title: 'Chargable Weeight'},
              // }, 
              colors:  ['#D1C4E9','#B3E5FC','#D7CCC8','#F48FB1']
              ,
            height:580,
            }
          }
  
          var temp=[];
          var k=[];
           k.push('Day')
           
           sll.forEach(element => {
              k.push(element)
           });
           k.push({role:'annotation'})
           temp.push(k)
  
           
           //console.log(ddate);
           var c=0;
           ddate.forEach(element => {
            var j=[];
            j.push(this.weeekday[c]) 
            var total=0;
            sll.forEach(pelement => {
              var arra=this.getkg_sl(pelement,element);
              //console.log(arra)
              if(arra.length>0)
               {
                  j.push(arra[0].COB_WEIGHT_CHARGEABLE)
                  total=total+arra[0].COB_WEIGHT_CHARGEABLE;
               }
               else
                 j.push(0) 
             });
             c=c+1;
             j.push(total)
            
             temp.push(j);
           });
           
           for(var i=ddate.length;i<7;i++)
           {
            var k=[];
              k.push(this.weeekday[i])
             sll.forEach(pelement => {
               k.push(0)
             });
             k.push(0)
            temp.push(k);
  
           }
           //console.log("sl")
  
           //console.log(temp)
          var barchart_sl = {
            chartType: 'ColumnChart',
            dataTable: temp,
             options: {
              options: {
        
                title: 'Monthly Spend Variance',
                
              },
              annotations: {
                textStyle: {
                color:'black'
                }
              },
              legend: { position: 'top', alignment: 'center' },
              isStacked:true,
  
              bar: { groupWidth: "50%" },
              'chartArea': {'width': '75%', 'height': '75%'},
  
              vAxis: {  gridlines: {
                color: 'transparent'
              },
              textPosition: 'none' 
            },
            
            hAxis: {  gridlines: {
              color: 'transparent'
             }},
        
          
              // isStacked:"true",
              
              // vAxes: {
              //   // Adds titles to each axis.
              //   0: {title: 'Chargable Weeight'},
              // }, 
              colors:  ['#9CCC65','#FFD54F','#FF8A65']
              ,
            height:380,
            }
          }
          //console.log(barchart)
  
  
  
          this.barchart=barchart;
          this.barchart_sl=barchart_sl;
  
          var temp=[];
  
          temp.push(['Service Level','Capacity'])
   
          var pidata= this.barchart_sl.dataTable[this.selectedday+1];
   
   
   
          var kn=1;
          //console.log(this.barchart_sl.dataTable[0])
          pidata.slice(1,pidata.length-1).forEach(element => {
           
           //console.log(element)
           temp.push([this.barchart_sl.dataTable[0][kn],element])
            kn=kn+1;
          });
          //console.log(temp);
   
       
   
   
       var sl_pi_selected = {
         chartType: 'PieChart',
         dataTable: [],
          options: {
           options: {
     
             title: 'Total Booked',
             
           },
           pieSliceTextStyle: {
             color: 'black',
             fontSize:11
           },
           
           pieStartAngle: 180,
   
           legend:'none',
           colors:  ['#9CCC65','#FFD54F','#FF8A65']
           ,
           'chartArea': {'width': '100%', 'height': '90%'},
   
         height:150,
         }
       }
   
       
       sl_pi_selected.dataTable=temp;
       this.selecteddaydonat_sl=sl_pi_selected;
       //console.log(this.selecteddaydonat_sl);
   
          //barchartlst list
  
        
  
          // this.sl_partnerlist=[];
          // var sls_date=this.resultdata.sl_date.filter(function(item:any){
          //   return item.Date===this.resultdata.date[this.selectedday].Date})
     
        // var sls_date=[];    
        //   sls_date.forEach(element => {
     
        //    var bchartsmall = {
        //      chartType: 'PieChart',
        //      dataTable: [],
        //       options: {
        //        options: {
         
        //          title: 'Total Booked',
                 
        //        },
        //        pieHole:0.4,
        //        pieSliceTextStyle: {
        //          color: 'black',
        //          fontSize:8
        //        },
               
        //        pieStartAngle: 180,
       
        //        legend:'none',
        //        colors: ['#5C6BC0','#C5CAE9']
        //        ,
        //        'chartArea': {'width': '100%', 'height': '90%'},
       
        //      height:80,
        //      }
        //    }
       
          //  var sl_date_Emp=JSON.parse(JSON.stringify(this.resultdata.sl_date));
         
          //  //console.log(sl_date_Emp)
            // var temp=[];
            // temp.push(['Title','Capacity'])
            // var booked=element.COB_WEIGHT_CHARGEABLE_y;
            // var cob=element.COB_WEIGHT_CHARGEABLE;
            // if(element.COB_WEIGHT_CHARGEABLE==null)
            //    cob=0
     
            // if(element.COB_WEIGHT_CHARGEABLE_y==null)
            //    booked=0
     
            // temp.push(['COB',cob])
            // temp.push(['Total Remaining',booked-cob])
     
            // bchart.dataTable=temp;
            
            // var temp=[];
     
            // temp.push(['Title','Capacity'])
     
            // temp.push(['COB',cob])
            // temp.push(['Total Remaining',element.COB_WEIGHT_CHARGEABLE_x-cob])
     
            // var bchartb=JSON.parse(JSON.stringify(bchart))
            // bchartb.dataTable=temp;
     
  //          this.sl_partnerlist.push({"partner":element.PARTNER,"receipt":element.COB_WEIGHT_CHARGEABLE_x,"booked":booked,"cob":cob,"graph":bchart,"graphb":bchartb})
            // //console.log(this.partnergraphlist);
     
  //        });
  
          //selected day
  
          var daydonat = {
            chartType: 'PieChart',
            dataTable: [],
             options: {
              options: {
        
                title: 'Total Booked',
                
              },
              pieSliceTextStyle: {
                color: 'black',
                fontSize:11
              },
              
              pieStartAngle: 180,
      
              legend:'none',
              colors: ['#D1C4E9','#B3E5FC','#D7CCC8','#F48FB1']
              ,
              'chartArea': {'width': '100%', 'height': '90%'},
      
            height:150,
            }
          }
  
          var daydonat_res = {
            chartType: 'PieChart',
            dataTable: [],
             options: {
              options: {
        
                title: 'Total Booked',
                
              },
              pieSliceTextStyle: {
                color: 'black',
                fontSize:11
              },
              
              pieStartAngle: 180,
      
              legend:'none',
              colors: ['#D1C4E9','#B3E5FC','#D7CCC8','#F48FB1']
              ,
              'chartArea': {'width': '100%', 'height': '90%'},
      
            height:150,
            }
          }
   
      
           var temp=[];
           temp.push(['Partner','Capacity'])
  
           dpartner.forEach(element => {
  
            //console.log(element,this.resultdata.date[this.selectedday].Date)
            
            ;
                  var array=this.getkg(element,this.resultdata.date[this.selectedday].Date)
                  if(array.length>0)
                   temp.push([element,array[0].COB_WEIGHT_CHARGEABLE]);
                  else
                    temp.push([element,0]);
           });      
           daydonat.dataTable=temp;
           //console.log(daydonat.dataTable)
           this.selecteddaydonat=daydonat;
           var temp=[];
           temp.push(['Partner','Capacity'])
  
           dpartner.forEach(element => {
  
            //console.log(element,this.resultdata.date[this.selectedday].Date)
            
            ;
                  var array=this.getkg(element,this.resultdata.date[this.selectedday].Date)
                  if(array.length>0)
                   temp.push([element,array[0].COB_WEIGHT_CHARGEABLE_x]);
                  else
                    temp.push([element,0]);
           });      
  
           daydonat_res.dataTable=temp;
           this.selecteddaydonat_res=daydonat_res;
  
  
           var daydonat_booked=JSON.parse(JSON.stringify(daydonat_res));
           var temp=[];
           temp.push(['Partner','Capacity'])
    
           dpartner.forEach(element => {
    
            //console.log(element,this.resultdata.date[this.selectedday].Date)
            
            ;
                  var array=this.getkg(element,this.resultdata.date[this.selectedday].Date)
                  if(array.length>0)
                   temp.push([element,array[0].COB_WEIGHT_CHARGEABLE_y]);
                  else
                    temp.push([element,0]);
           });      
    
           daydonat_booked.dataTable=temp;
           this.selecteddaydonat_booked=daydonat_booked;
  
           //sll
           
  
           var temp=[];
        temp.push(["Title","Value"])
        // var lastweek=this.resultdata.week_snap[0]['Observed Chargeable Weight'];
        // var pred=this.resultdata.week_snap[0]['Predicted Chargeable Weight'];
        // if(this.resultdata.week_snap[0]['Observed Chargeable Weight']==0)
        //   lastweek=null
        // if(this.resultdata.week_snap[0]['Predicted Chargeable Weight']==0)
        //   pred=null
  
        temp.push(["Total Booked",this.resultdata.date[this.selectedday].COB_WEIGHT_CHARGEABLE])
        temp.push(["Total Received",this.resultdata.date[this.selectedday].COB_WEIGHT_CHARGEABLE_x])
   
       
        var clchart =JSON.parse(JSON.stringify(cchart)) 
        clchart.options.height="140"
        clchart.dataTable=temp;
        this.selecteddayBar=clchart;
  
        var allocation_chart_pi = {
          chartType: 'PieChart',
          dataTable: [],
           options: {
            options: {
      
              title: 'Total Booked',
              
            },
           
            pieSliceTextStyle: {
              color: 'black',
              fontSize:12
            },
            
            legend:'none',
            // legend: { position: 'top', alignment: 'center' },
            colors:  ['#80DEEA','#D4E6F1']
            ,
            'chartArea': {'width': '100%', 'height': '100%'},
    
          height:140,
          }
        }
        var temp=[]
  
        temp.push(['Type','Value'])
        temp.push(['BaseAllocation',this.allocation.base])
        temp.push(['Flex',this.allocation.flex])
  
        allocation_chart_pi.dataTable=temp;
        this.allocation_donat=allocation_chart_pi;
  
        var allocation_partnerdist = {
          chartType: 'BarChart',
          dataTable: temp,
           options: {
            options: {
      
              title: 'Monthly Spend Variance',
              
            },
            'chartArea': {'width': '60%', 'height': '70%'},
  
            annotations: {
              textStyle: {
              color:'black',
              fontSize:12
              }
            },
            // legend:'none',
            legend: { position: 'top', alignment: 'left' },
            isStacked:true,
  
            bar: { groupWidth: "50%" },
  
            vAxis: {  gridlines: {
              color: 'transparent'
            }
          },
          
          hAxis: {  gridlines: {
            color: 'transparent',
  
           }         , textPosition: 'none' 
          },
      
        
            // isStacked:"true",
            
            // vAxes: {
            //   // Adds titles to each axis.
            //   0: {title: 'Chargable Weeight'},
            // }, 
            colors:  ['#80DEEA','#D4E6F1']
            ,
          height:200,
          }
        }
  
        var temp=[]
  
        var  k=[];
        temp.push(['Partner','Base','Flex',{role:'annotation',}])
  
        // temp.push(['Type','Value'])
        this.resultdata.partner_config.forEach(element => {
          var base=0,flex=0;
          if(element.Baseallocation!=null)
            base=element.Baseallocation;
          if(element.Flex!=null)
            flex=element.Flex;
  
  
          temp.push([element.Partner,base,flex,base+flex])
   
        });
      
        //console.log(temp);
        allocation_partnerdist.dataTable=temp;
        this.allocation_partnerdist=JSON.parse(JSON.stringify(allocation_partnerdist));
  
        var allocation_linechart = {
          chartType: 'LineChart',
          dataTable: [],
           options: {
           
            'chartArea': {'width': '75%', 'height': '75%'},
  
            vAxis: {  gridlines: {
              color: 'transparent'
            },
          },
          annotations: {
            textStyle: {
            color:'black'
            },
            axisTitlesPosition:'in'       
           },
          
  //        legend:'none',
          // seriesType: 'line',
          // series: {1: {type: 'bars',targetAxisIndex:0}},        
  
          hAxis: {  gridlines: {
            color: 'transparent'
           }},
            // hAxis:{format:'MM-dd-yyyy'},
            height:400,
    
            colors: ['#9B59B6','#138D75','#CA6F1E','#273746']
  
                  },
          
    
                  
          }
  
          var temp = []
  
          temp.push(['Date','Total Available','Total Moved Upto',{role:'annotation',index:0}])
  
          var total = 0
          
          // this.resultdata.partner.forEach(element => {
          //    total =total + element.Flex+element.Baseallocation; 
          // });
          var totalmoving=0;
          var w=0;
          this.resultdata.date.forEach(element => {
            totalmoving=totalmoving+element.COB_WEIGHT_CHARGEABLE;
            temp.push([this.weeekday[w++],this.allocation.totalallocation,totalmoving,totalmoving])
         });
  
  
         allocation_linechart.dataTable=temp;
         this.allocationconsumeline=allocation_linechart;
  
  
         var serieslist=[];
         var colorlist=['#A93226','#6C3483','#2874A6','#0E6655','#B9770E','#909497','#283747']
     
         var c=0;
         this.resultdata.partner.forEach(element => {
     
            serieslist.push({color:colorlist[c]})
          // copydata[0].push('Total '+element.PARTNER)
          c++;
  
         });
  
  
         var c=0;
         this.resultdata.partner.forEach(element => {
     
            serieslist.push({color:colorlist[c],lineDashStyle: [10, 2],pointSize:3})
          // copydata[0].push('Total '+element.PARTNER)
          c++;
         });
  
  
         //console.log(serieslist);
         var allocation_linechart_s = {
          chartType: 'LineChart',
          dataTable: [],
           options: {
           
            'chartArea': {'width': '75%', 'height': '75%'},
  
            vAxis: {  gridlines: {
              color: 'transparent'
            },
            // seriesType: 'line',
            // series: {1: {color:'#9B59B6'},2: {color:'#138D75'},3: {color:'#CA6F1E'},4: {color:'#273746'},6: {color:'#9B59B6',lineDashStyle: [1, 1]},7: {color:'#138D75',lineDashStyle: [1, 1]},8: {color:'#CA6F1E',lineDashStyle: [1, 1]},9: {color:'#273746',lineDashStyle: [1, 1]}},        
    
          },
          
          legend:{ position: 'top', alignment: 'center' },
          // seriesType: 'line',
          // series: {0: {color:'red'},1: {color:'blue'},2: {color:'black'},3: {color:'red',lineDashStyle: [10, 2],pointSize:0},4: {color:'blue',lineDashStyle: [10, 2],pointSize:0},5: {color:'black',lineDashStyle: [10, 2],pointSize:0}},        
          series:Object.assign({}, serieslist),
          hAxis: {  gridlines: {
            color: 'transparent'
           }},
           
            // hAxis:{format:'MM-dd-yyyy'},
            height:400,
            pointSize:3,
    
            // colors: ['#9B59B6','#138D75','#CA6F1E','#273746']
            
           },
          
    
                  
          }
          //console.log(allocation_linechart_s.options.series);
  
  
        //   var temp = []
  
        //   temp.push(['Date','Total Available','Total Moved Upto',{role:'annotation',index:0}])
  
        //   var total = 0
          
        //   this.resultdata.partner.forEach(element => {
        //      total =total + element.Flex+element.Baseallocation; 
        //   });
        //   var totalmoving=0;
        //   var w=0;
        //   this.resultdata.date.forEach(element => {
        //     totalmoving=totalmoving+element.COB_WEIGHT_CHARGEABLE;
        //     temp.push([this.weeekday[w++],total,totalmoving,totalmoving])
        //  });
  
  
  
  
        //  //console.log(this.barchart.dataTable.length);
        var copydata=JSON.parse(JSON.stringify(this.barchart.dataTable)) 
  
        
  
        for(var i=1;i<copydata.length;i++) {
          for(var j=1;j<copydata[0].length-1;j++){
  
  
            if(i>1)
            {
              
               copydata[i][j]=copydata[i][j] + copydata[i-1][j];
               
              // temp1.total=temp1.total+this.barchart.dataTable[i-1][j]
  
            }
            else{
  
  
           }
         
    
          }
          // var m=0;
          // copydata[i][copydata[0].length-1]=null
  
          
        }
        var ct=JSON.parse(JSON.stringify(copydata[0]));
        ct.splice(0,1)
        //console.log(ct);
        ct.splice(copydata[0].length-1,1)
         ct.forEach(element => {
          //console.log(element)
          copydata[0].push('Total '+element)
  
        });
  
       copydata[0].splice(copydata[0].length-1,1);
        for(var i=1;i<copydata.length;i++) {
            ct.forEach(element => {
              var padb=this.resultdata.partner.filter(function(item:any){return item.PARTNER===element})
               //console.log(padb)
               if(padb.length>0)
                 copydata[i].push(padb[0].Flex+padb[0].Baseallocation)
          });
        }
        var temp=[];
        temp.push(copydata[0])
        temp[0].splice(this.resultdata.partner.length+1, 1);
  
        for(var i=0,j=1;i<copydata.length;i++,j++) {
               
             if(i<this.resultdata.date.length)
             {
                copydata[j].splice(this.resultdata.partner.length+1, 1);
                temp.push(copydata[j])
             }
        }
  
        allocation_linechart_s.dataTable=temp;
        this.allocation_linechart_s=allocation_linechart_s;
        //console.log(allocation_linechart_s);
  
  
  
        //partner by sl
  
        var dpartner = this.resultdata.sl_date
        .map((item) => item.PARTNER)
        .filter(
            (value, index, current_value) => current_value.indexOf(value) === index
        );
  
        //service level by partner distribution
        var date=this.resultdata.date[this.selectedday].Date;
  
  
        var sls_date=this.resultdata.sl_date.filter(function(item:any){
          return item.Date===date})
  
          this.sl_partnerlist=[];
           //console.log(sls_date)
           dpartner.forEach(element => {
            var total_sl="";
                var bchartsmall = {
             chartType: 'PieChart',
             dataTable: [],
              options: {
               options: {
         
                 title: 'Total Booked',
                 
               },
               pieSliceTextStyle: {
                 color: 'black',
                 fontSize:8
               },
               
               pieStartAngle: 180,
       
               legend:'none',
               colors:  ['#9CCC65','#FFD54F','#FF8A65']
               ,
               'chartArea': {'width': '100%', 'height': '90%'},
       
             height:90,
             }
           }
           
           var sllist_p:any=sls_date.filter(function(item:any){return item.PARTNER===element})
           
           var sl = ['STD','DEF','EXP']
          //  var sllist:any=sls_date.filter(function(item:any){return item.PARTNER===element})
           var sllist=[] 
           sl.forEach(element => {
            var sllist_t:any=sllist_p.filter(function(item:any){return item['Service Level']===element})
            if(sllist_t.length>0)
              sllist.push(sllist_t[0])
            else
             {
              var obj ={
                "Date": this.resultdata.date[this.selectedday],
                "PARTNER": 0,
                "Service Level":element,
                "COB_WEIGHT_CHARGEABLE_x": 0,
                "COB_WEIGHT_CHARGEABLE_y": 0,
                "COB_WEIGHT_CHARGEABLE": 0
            }
               sllist.push(obj)
             }
           });
    
    
           //console.log(sllist);
  
  
   
  
  
  
           var temp=[];
           temp.push(['Service Level','Value'])
           sllist.forEach(element => {
            temp.push([element['Service Level'],element.COB_WEIGHT_CHARGEABLE])
            total_sl=total_sl+element.COB_WEIGHT_CHARGEABLE
            
           });
            var graphs=JSON.parse(JSON.stringify(bchartsmall));
             graphs.dataTable=temp;
             this.sl_partnerlist.push({"sl":element,"graph":graphs,"total STD":total_sl})
           });
           //console.log( this.sl_partnerlist)
  
    }
  
    partner_sumline=[];
    allocation_linechart_s:any;
    allocation_partnerdist:any;
    remaing=[];
    totalaloc=0;
    setorg(){
      this.user.oring=this.user.lane.split("-")[0];
      this.user.destination=this.user.lane.split("-")[1];
  
      this.refresh();
  //    this.flag=false;
    //   this.service.postData(this.user, 'get_daily_monitering').then((result) => {
    //     var res:any=result;
    //     this.alldata=result;
    //     this.alldata.dailyd=JSON.parse(res.dailyd);
    //     this.alldata.partnerc=JSON.parse(res.partnerc);
    //     this.alldata.wdf=JSON.parse(res.wdf);
    //     this.alldata.temp.chargablewt=parseFloat(this.alldata.temp.chargablewt)
    //     this.alldata.temp.MVA2w=parseFloat(this.alldata.temp.MVA2w)
    //     this.alldata.temp.MVA4w=parseFloat(this.alldata.temp.MVA4w)
    //     this.alldata.temp.MVA3m=parseFloat(this.alldata.temp.MVA3m)
    //     this.alldata.temp.pred1=parseFloat(this.alldata.temp.pred1)
    //     this.alldata.temp.pred2=parseFloat(this.alldata.temp.pred2)
    //     //console.log(this.alldata);
      
    //     this.cal();
    //        var unique_values = this.alldata.dailyd
    //           .map((item) => item.Booked)
    //           .filter(
    //               (value, index, current_value) => current_value.indexOf(value) === index
    //           );
    //           this.dpartner = this.alldata.dailyd
    //           .map((item) => item.PARTNER)
    //           .filter(
    //               (value, index, current_value) => current_value.indexOf(value) === index
    //           );
  
    //           //console.log(this.dpartner);
    //           this.graphdata=[];
    //           unique_values.forEach(element => {
                
    //             var total=0;
    //             var partner=[]
    //             this.alldata.dailyd.forEach(k => {
             
    //                if(k.Booked==element)
    //                {
    //                  total=total+k.Chargeable_Weight;
    //                  partner.push(k)
    //                }
    //             });
  
                
  
    //             this.graphdata.push({date:element,total:total,partner:partner});
    //           });
    //           //console.log(this.graphdata)
    //  //         this.setgraph();
    //   });
      
    }
  
    cal(){
  
      this.totalaloc=0;
  
      this.alldata.partnerc.forEach(element => {
  
        this.totalaloc=this.totalaloc+element.Baseallocation+element.Flex+element.PeakAllocation;
  
      });
  
      this.totalallocated=0
      this.remaing=[];
      this.alldata.wdf.forEach(element => {
         
        var details=this.getalloc(element.PARTNER)
        if(details.length>0)
          this.remaing.push({base:details[0].Baseallocation,flex:details[0].Flex,peak:details[0].PeakAllocation,total:details[0].Baseallocation+details[0].Flex+details[0].PeakAllocation,perc:details[0].PercentageAllocation})
        else
          this.remaing.push({base:0,flex:0,peak:0,total:0,perc:0})
        this.totalallocated=this.totalallocated+element.Chargeable_Weight;
  
      });
      this.flag=true;
    }
    
    getalloc(partner){
  
      var padb=this.alldata.partnerc.filter(function(item:any){return item.Partner===partner})
     
        return padb;
    
      }
    
    
    
     getDates(startDate, stopDate) {
       var dateArray = new Array();
       var currentDate = startDate;
       while (currentDate <= stopDate) {
         dateArray.push(currentDate)
         currentDate = currentDate.addDays(1);
       }
       return dateArray;
     }
    
    
    
      getkg(k,date){
        var padb=this.resultdata.partner_date.filter(function(item:any){return item.PARTNER===k&&item.Date===date&&item.COB_WEIGHT_CHARGEABLE!=null})
     
        return padb;
      }
      getkg_sl(k,date){
        var padb=this.resultdata.sl_partner_Date.filter(function(item:any){return item['Service Level']===k&&item.Date===date&&item.COB_WEIGHT_CHARGEABLE!=null})
     
        return padb;
      }
      onItemSelect(e){}
      onSelectAll(e){}
    ngOnInit() {
      this.dropdownSettings = {
        singleSelection: false,
        idField: 'Lane',
        textField: 'Lane',
        selectAllText: 'Select All',
        unSelectAllText: 'UnSelect All',
        itemsShowLimit: 3,
        allowSearchFilter: true
      };
    }
  
    selectdate(event) {
      //console.log(event);
      if(event.selectedRowValues.length>0)
      {
       //  this.selectedday=event.row;
         
  
      //  if(event.column==1)
      //  {
        
      this.user.partner=this.allocation_linechart_s.dataTable[0][event.column];
  
  
      
  
      var utcdate=new Date(this.resultdata.date[event.row].Date).toLocaleString('en-US', { timeZone: 'UTC' });
      var w=utcdate.split(",")[0]
      var date = moment(this.user.startdate).add(event.row, 'd').format('MM/DD/YYYY');
          //console.log(date)
          this.presentModal_shipper_d(date);
          // this.presentModal_3b18_d(this.week[event.row])
      //  }else 
   
      //   {
  
      //   }
      }
    }
    selectweek(event) {
      //console.log(event);
      if(event.selectedRowValues.length>0)
      {
       //  this.selectedday=event.row;
         
  
       if(event.column==1)
       {
          //console.log(event.row)
          this.presentModal_3b18_d(this.week[event.row])
       }else 
      {
         if(this.flag_3b18=='g'&& event.column==6){
       
         var k=this.LineChartdata_13week.dataTable[event.row+1][0];
  //       var week= (new Date(this.LineChartdata_13week.dataTable[this.selectedday][0]).getMonth()+1)+'/'+new Date(this.LineChartdata_13week.dataTable[this.selectedday][0]).getDate()+'/'+new Date(this.LineChartdata_13week.dataTable[this.selectedday][0]).getFullYear();
         //console.log(k);
  
         var padb=this.shipeerdata.filter(function(item:any){
        
          var utcdate=new Date(item.Week).toLocaleString('en-US', { timeZone: 'UTC' });
          var w=utcdate.split(",")[0]
          return w===k
        
        })
         this.service.shipperdata=padb;
         this.presentModal();
         }
         if((this.flag_3b18=='p'||this.flag_3b18=='r')&& event.column==4){
       
          var k=this.LineChartdata_13week.dataTable[event.row+1][0];
   //       var week= (new Date(this.LineChartdata_13week.dataTable[this.selectedday][0]).getMonth()+1)+'/'+new Date(this.LineChartdata_13week.dataTable[this.selectedday][0]).getDate()+'/'+new Date(this.LineChartdata_13week.dataTable[this.selectedday][0]).getFullYear();
          //console.log(k);
   
          var padb=this.shipeerdata.filter(function(item:any){
         
           var utcdate=new Date(item.Week).toLocaleString('en-US', { timeZone: 'UTC' });
           var w=utcdate.split(",")[0]
           return w===k
         
         })
          this.service.shipperdata=padb;
          this.presentModal();
          }  
        }
       }
      
    }
  
    selectweeklist(event,flag) {
      //console.log(event);
      if(event.selectedRowValues.length>0)
      {
       //  this.selectedday=event.row;
         
  
       if(event.column==1)
       {
  
         this.flag_3b18=flag;
          // //console.log(event.row)
          // this.presentModal_3b18()
       }else 
       {
         if(this.flag_3b18=='g'&& event.column==6){
       
         var k=this.LineChartdata_13week.dataTable[event.row+1][0];
  //       var week= (new Date(this.LineChartdata_13week.dataTable[this.selectedday][0]).getMonth()+1)+'/'+new Date(this.LineChartdata_13week.dataTable[this.selectedday][0]).getDate()+'/'+new Date(this.LineChartdata_13week.dataTable[this.selectedday][0]).getFullYear();
         //console.log(k);
  
         var padb=this.shipeerdata.filter(function(item:any){
        
          var utcdate=new Date(item.Week).toLocaleString('en-US', { timeZone: 'UTC' });
          var w=utcdate.split(",")[0]
          return w===k
        
        })
         this.service.shipperdata=padb;
         this.presentModal();
         }
         if((this.flag_3b18=='p'||this.flag_3b18=='r')&& event.column==4){
       
          var k=this.LineChartdata_13week.dataTable[event.row+1][0];
   //       var week= (new Date(this.LineChartdata_13week.dataTable[this.selectedday][0]).getMonth()+1)+'/'+new Date(this.LineChartdata_13week.dataTable[this.selectedday][0]).getDate()+'/'+new Date(this.LineChartdata_13week.dataTable[this.selectedday][0]).getFullYear();
          //console.log(k);
   
          var padb=this.shipeerdata.filter(function(item:any){
         
           var utcdate=new Date(item.Week).toLocaleString('en-US', { timeZone: 'UTC' });
           var w=utcdate.split(",")[0]
           return w===k
         
         })
          this.service.shipperdata=padb;
          this.presentModal();
          }  
        }
       }
      
    }
  
    async presentModal() {
      const modal = await this.modalController.create({
        component: OceanShipperDataComponent,
        // componentProps: {
        // //  bardata: this.bars
        // }
      });
      return await modal.present();
    }
  
    grapgflag='s'
    configflag=true
    alldatalane:any=[];
    laneconfig:any=[]
    gotodem(){
      this.router.navigateByUrl('/demandsensingnew');
  
    }
   presentgraph(k) {
      this.alldatalane= this.prediction_list_all_lane.filter(function(item:any){return item['Lane']===k})

      this.selectedlanes=k;

    this.grapgflag='g'
    
     
    }

    async presentModal_3b18() {
      const modal = await this.modalController.create({
        component: Ocean3b81detailsComponent,
        componentProps: {
           weekdata: this.week,
           flag:'w'
        }
      });
      return await modal.present();
    }
    

    async presentModal_3b18_d(w) {
      //console.log(w);
  
      const modal = await this.modalController.create({
        component: Ocean3b81detailsComponent,
        componentProps: {
           weekdata: this.week,
           flag:'d',
           selectedweek:w
        }
      });
      return await modal.present();
    }
  
    async presentModal_shipper_d(w) {
      //console.log(w);
  
      this.user.date=w;
      const modal = await this.modalController.create({
        component: ShipercobdataComponent,
        componentProps: {
          user: this.user,
          flag:'d'
        }
      });
      return await modal.present();
    }
    GOtoNExtPage_2() {
      
      this.router.navigateByUrl('/operational-concern');
    }
    gototraining(){
      this.router.navigateByUrl('/dailytraining');
  
    }
    GOtoNExtPage_1() {
      
      this.router.navigateByUrl('/dashboard');
    }
    GOtoNExtPage_P()
    {
      this.router.navigateByUrl('/operational-concern1');
    }
    GOtomessage() {
        
      this.router.navigateByUrl('/messages');
    }
   
  
    go_config()
    {
      this.router.navigateByUrl('/userprofile');
    
    }
  
  }
  